/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import history from "../../../config/history";

import CommonActions from "../actions";
import siteActions from "../../site/actions";
import regionActions from "../../region/actions";
import dashboardAction from "../../dashboard/actions";
import {
    buildDashboardReportParams,
    getSessionDefaultProjectId,
    resolveSessionDefaultProject,
    setSessionDefaultClients
} from "../../../utils/dashboardSession";
import store from "../../../store/configureStore";

import buildingActions from "../../building/actions";
import recommentationActions from "../../recommendations/actions";
import Footer from "./footer";

import SideNav from "../../common/components/SideNav/SideNav";
import SidePanel from "../../dashboard/components/sidePanel";
import {
    resetBreadCrumpData,
    bulkResetBreadCrumpData,
    checkPermission,
    findInfoPathFromBreadCrump,
    isAssetDefaultDashboard,
    getDefaultDashboardLocation,
    setDefaultDashboardView,
    isMobileAssetDefaultDashboard
} from "../../../config/utils";
import ConfirmationModal from "./ConfirmationModal";
import Portal from "./Portal";
import { AssetSettingsEntities } from "../../assetSettings/config";
import { DocumentSettingsEntities } from "../../documentSettings/config";
import ReactTooltip from "react-tooltip";
import { APP_MODE } from "../../../config/constants";
import trainingAppLogo from "../../../assets/img/logo-trainer.svg";
import { permissions } from "../../../config/permissions";
import dashboardProjecIcon from "../../../assets/img/proj-icon.svg";
import FavoriteIcon from "../../../assets/img/favourite-icn.svg";
import SmartChartReportsFavoriteListModal from "../../smartCharts/components/ReportsByTemplateModal";
import { addToQuickLinks, deleteQuickLinks, getQuickLinks } from "../../dashboard/actions";
import { navigateWithPrompts } from "../../../utils/navigationHelpers";
import { isEnabled } from "../../../services/featureFlags";
import { ACTIVE_SESSIONS_FLAG } from "../../activeSessions/constants";
import { canSeeAiSettings, canUseOttoPage, subscribeOttoAccess, OTTO_PAGES } from "../../filterAssistant/core/ottoAccess";
import { getCapitalRequestLabel } from "../../../utils/capitalRequestLabel";
import DashboardSwitcher, {
    SIDEBAR_CARD_TOOLTIP_ID,
    DASHBOARD_MENU_PERMISSION,
    DASHBOARD_OPTIONS,
    DEFAULT_DASHBOARD_VIEW_BY_KEY,
    FCA_DASHBOARD,
    getDashboardBreadCrumb,
    getDashboardPath,
    getDashboardTheme,
    isWithinDashboardSection
} from "./DashboardSwitcher";
import { applyDashboardTheme } from "../../../config/dashboardThemes";
import DefaultProjectPicker from "./DefaultProjectPicker";
import assetManagementActions from "../../assetManagement/actions";
import blueSearchIcon from "../../../assets/img/blue-searchs.svg";
import imageActions from "../../images/actions";
import userActions from "../../users/actions";
import dynamicTableActions from "../../dynamicTables/actions";
import { CLIENT_DYNAMIC_TABLES_PATH } from "../../dynamicTables/constants";
import {
    getAssetChartNavigationApiParams,
    getAssetDashboardFrom,
    getAssetDashboardSidePanelParams,
    resolveAssetDashboardFrom,
    getAssetEntityNavigationDisplayParams,
    getCombinedAssetDashboardFilterTags,
    getSourceShapedChartParams,
    isMobileAssetDashboard,
    hasAssetDashboardNavFilters
} from "../../assetDashboard/utils";

class SideMenu extends React.Component {
    state = {
        menuData: [],
        publishedDynamicTables: [],
        collapseAll: false,
        sidePanelValues: [],
        isDashboardClick: false,
        redirection: false,
        activeSection: "",
        activeBuildingType: "",
        selectedRegion: null,
        paginationParams: {
            totalPages: 0,
            perPage: 40,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 40,
            offset: 0,
            search: "",
            project_id: null,
            filters: null,
            list: null,
            deleted: null,
            locked: null,
            unlocked: null,
            active: true
        },
        wildCardFilterParams: {},
        filterParams: {},
        selectedRowId: null,
        selectedDropdown: "",
        filterValues: this.props.dashboardReducer.filterContents || {},
        dashboardFilterParams: this.props.dashboardReducer.filterValues,
        dashboardExtraFilters: this.props.dashboardReducer.dashboardExtraFilters,
        historyParams: this.props.regionReducer.entityParams.historyParams,
        showGotoLandingConfirmModal: false,
        projectName: [],
        showFavoriteSmartChartReportsModal: false,
        quickLinksConfirmationModal: { show: false, item: null },
        isFullView: true,
        flyoutSearchQuery: "",
        isFlyoutSearchExpanded: false,
        sidebarSearchQuery: "",
        menuSearchTree: [],
        activeMenuSearchQuery: "",
        isSidebarSearchTypingLoading: false,
        isSidebarSearchRequestPending: false,
        forceExpandPath: [],
        activeFlyoutPath: [],
        quickLinkFocus: false
    };
    flyoutSearchInputRef = React.createRef();
    sideNavSearchInputRef = React.createRef();
    menuSearchCache = {};
    menuSearchBaseMenuData = null;
    sidebarSearchDebounceTimer = null;
    // Stats-panel mode (true = asset view) already requested by syncStatsPanelMode. Guards against the
    // componentDidUpdate -> getDashboard -> REQUEST -> re-render -> componentDidUpdate loop: the request
    // itself re-renders this component before the response lands, so the mismatch would re-trigger forever.
    statsPanelRequestedMode = null;

    componentDidMount = async () => {
        this.syncDashboardTheme();
        this.setMenuData();
        // Otto's grants arrive asynchronously (see filterAssistant/core/ottoAccess). setMenuData runs once
        // on mount, so without this the AI Settings entries would stay hidden for a granted non-admin until
        // the next full page load.
        this.unsubscribeOttoAccess = subscribeOttoAccess(() => this.setMenuData());
        this.refreshPublishedDynamicTables();
        if (this.isDashboardStatsRoute()) {
            this.setState({
                redirection: true
            });
        } else {
            await this.getSidePanelValues();
        }
        var element = document.getElementById("sidebar");
        element &&
            element.addEventListener("mouseover", e => {
                var navBrand = document.getElementById("navBrand");
                if (navBrand && !navBrand.contains(e.target)) {
                    element.classList.add("nav-hover");
                }
            });
        element &&
            element.addEventListener("mouseleave", e => {
                element.classList.remove("nav-hover");
            });
    };

    componentDidUpdate = (prevProps, prevState) => {
        this.syncDashboardTheme();
        if (prevProps.dashboardReducer.getDashboard !== this.props.dashboardReducer.getDashboard) {
            if (this.props.dashboardReducer.getDashboard) {
                if (this.isDashboardStatsRoute()) {
                    this.setState({
                        isDashboardClick: true
                    });
                }
                const dashboardData = this.props.dashboardReducer.getDashboard;
                const sidePanel = dashboardData?.["side_panel"];
                this.setState({
                    sidePanelValues: sidePanel
                        ? {
                              ...sidePanel,
                              is_asset_dashboard_view: dashboardData?.is_asset_dashboard_view
                          }
                        : sidePanel
                });
            }
        }

        // if(prevState.isDashboardClick!=this.state.isDashboardClick){
        //     if (this.props.match.path == '/dashboard') {
        //         this.setState({
        //             isDashboardClick: true
        //         })
        //     }
        // }

        if (prevProps.dashboardReducer.filterContents !== this.props.dashboardReducer.filterContents) {
            if (this.props.dashboardReducer.filterContents && !this.props.dashboardReducer.filterContents.length) {
                this.setState({
                    activeBuildingType: ""
                });
            }
            this.setState({
                filterValues: this.props.dashboardReducer.filterContents || [],
                dashboardFilterParams: this.props.dashboardReducer.filterValues || []
            });
        }
        if (prevProps.dashboardReducer.filterValues !== this.props.dashboardReducer.filterValues) {
            this.setState({
                filterValues: this.props.dashboardReducer.filterContents || [],
                dashboardFilterParams: this.props.dashboardReducer.filterValues || []
            });
        }
        if (prevProps.match.path !== this.props.match.path) {
            if (this.isDashboardStatsRoute()) {
                this.setState({
                    activeSection: "",
                    // activeBuildingType: '',
                    redirection: true
                });
            }
        }
        this.syncStatsPanelMode();
        this.focusMenuForCurrentRoute();
        if (this.props.match.path === "/dashboard" && prevProps.location.key !== this.props.location.key) {
            this.collapseAllItem();
        }
        if (prevProps.dashboardReducer?.defaultProject !== this.props.dashboardReducer.defaultProject) {
            if (!this.isDashboardStatsRoute()) {
                this.getSidePanelValues();
            }
            this.setMenuData();
            this.refreshPublishedDynamicTables();
        }
        const { dynamicTableReducer: prevDynamicTables } = prevProps;
        const { dynamicTableReducer: dynamicTables } = this.props;

        // Rebuild only from a successful fetch, so a failed one leaves the menu as it was rather than emptying it.
        if (prevDynamicTables?.getPublishedDynamicTablesResponse !== dynamicTables?.getPublishedDynamicTablesResponse) {
            const response = dynamicTables?.getPublishedDynamicTablesResponse;
            if (response?.success) {
                this.setState({ publishedDynamicTables: response.dynamic_tables || [] }, () => this.setMenuData());
            }
        }

        if (
            prevDynamicTables?.addDynamicTableResponse !== dynamicTables?.addDynamicTableResponse ||
            prevDynamicTables?.updateDynamicTableResponse !== dynamicTables?.updateDynamicTableResponse ||
            prevDynamicTables?.deleteDynamicTableResponse !== dynamicTables?.deleteDynamicTableResponse
        ) {
            this.refreshPublishedDynamicTables();
        }

        const { getEfciMenuItemsResponse, getProjectMenuItemsResponse } = this.props.commonReducer;

        if (
            prevProps.commonReducer?.getProjectMenuItemsResponse?.projects !== getProjectMenuItemsResponse?.projects ||
            prevProps.commonReducer?.getEfciMenuItemsResponse?.efcis !== getEfciMenuItemsResponse?.efcis
        ) {
            const projectIncoming = getProjectMenuItemsResponse?.projects ?? [];
            const efciIncoming = getEfciMenuItemsResponse?.efcis ?? [];

            this.setState(prevState => {
                let updatedMenu = [...prevState.menuData];
                let changed = false;

                updatedMenu = updatedMenu.map(menu => {
                    if (menu.key === "projects") {
                        const existing = menu.nodes ?? [];
                        if (this.shouldUpdateFlyoutMenuNodes(existing, projectIncoming)) {
                            changed = true;
                            return { ...menu, nodes: projectIncoming };
                        }
                    }

                    if (menu.key === "efci") {
                        const existing = menu.nodes ?? [];
                        if (this.shouldUpdateFlyoutMenuNodes(existing, efciIncoming)) {
                            changed = true;
                            return { ...menu, nodes: efciIncoming };
                        }
                    }

                    return menu;
                });

                return changed ? { menuData: updatedMenu } : null;
            });
        }
        if (prevState.isDashboardClick !== this.state.isDashboardClick && this.state.isDashboardClick) {
            this.setState({ showFlyout: false, hoveredItem: null, flyoutSearchQuery: "", isFlyoutSearchExpanded: false });
        }
        const menuSearchResponse = this.props.commonReducer?.menuSearchResponse;
        if (prevProps.commonReducer?.menuSearchResponse !== menuSearchResponse) {
            this.handleMenuSearchResponse(menuSearchResponse);
        }

        // const flyoutOpen = this.state.showFlyout && this.state.hoveredItem && !this.state.isDashboardClick;
        // const prevFlyoutOpen = prevState.showFlyout && prevState.hoveredItem && !prevState.isDashboardClick;

        // if (flyoutOpen && !prevFlyoutOpen) {
        //     document.addEventListener("keydown", this.flyoutTypeKeyListener, true);
        // }
        // if (!flyoutOpen && prevFlyoutOpen) {
        //     document.removeEventListener("keydown", this.flyoutTypeKeyListener, true);
        // }
    };

    componentWillUnmount = () => {
        clearTimeout(this.sidebarSearchDebounceTimer);
        if (this.unsubscribeOttoAccess) this.unsubscribeOttoAccess();
    };

    isDashboardStatsRoute = () => ["/dashboard", "/assetdashboard"].includes(this.props.match.path);

    syncDashboardTheme = () => {
        const theme = getDashboardTheme(this.getActiveDashboardKey());
        if (theme === this.appliedDashboardTheme) return;
        this.appliedDashboardTheme = theme;
        applyDashboardTheme(theme);
    };

    isAssetDashboardRoute = () => this.props.match.path === "/assetdashboard" || findInfoPathFromBreadCrump()?.[0]?.key === "assetDashboard";

    getAssetDashboardClient = () => {
        try {
            return JSON.parse(localStorage.getItem("asset_management_client")) || {};
        } catch (error) {
            return {};
        }
    };

    isFcaDashboardRoute = () => this.props.match.path === "/dashboard" || findInfoPathFromBreadCrump()?.[0]?.path?.toLowerCase() === "/dashboard";

    isAssetStatsView = () =>
        this.isAssetDashboardRoute() ||
        (!this.isDashboardStatsRoute() && !this.isFcaDashboardRoute() && isAssetDefaultDashboard() && !!this.getAssetDashboardClient()?.id);

    getDashboardReportParams = params =>
        buildDashboardReportParams(params, {
            masterBuildingTypes: this.props.dashboardReducer?.masterFilterList?.building_types || [],
            sessionDefaultProjectId: getSessionDefaultProjectId(this.props.dashboardReducer?.defaultProject)
        });

    findMenuPathForRoute = (items, pathname, trail = []) => {
        for (const item of items || []) {
            if (!item) continue;
            const nextTrail = [...trail, item];
            const deeper = this.findMenuPathForRoute(item.nodes, pathname, nextTrail);
            if (deeper) return deeper;

            const url = item.url ? `/${String(item.url).replace(/^\//, "")}` : null;
            if (url && (pathname === url || pathname.startsWith(`${url}/`))) return nextTrail;
        }
        return null;
    };

    clearQuickLinkFocus = () => {
        this.quickLinkFocusBase = null;
        this.quickLinkFocusedFor = null;
        if (this.state.quickLinkFocus) this.setState({ quickLinkFocus: false, forceExpandPath: [] });
    };

    // Latched on the section, not location.state: a page redirecting to a default child with history.replace drops the state.
    focusMenuForCurrentRoute = () => {
        const { pathname, state } = this.props.location;

        const base = this.quickLinkFocusBase;
        const withinFocusedSection = base && (pathname === base || pathname.startsWith(`${base}/`));
        if (this.isDashboardStatsRoute() || (!state?.fromQuickLink && !withinFocusedSection)) {
            this.clearQuickLinkFocus();
            return;
        }
        if (this.quickLinkFocusedFor === pathname) return;

        const path = this.findMenuPathForRoute(this.state.menuData, pathname);
        if (!path?.length) return;

        const matched = path[path.length - 1];
        this.quickLinkFocusBase = matched.url ? `/${String(matched.url).replace(/^\//, "")}` : null;
        this.quickLinkFocusedFor = pathname;
        this.setState({ isDashboardClick: false, forceExpandPath: path, quickLinkFocus: true });
    };

    syncStatsPanelMode = () => {
        if (this.isDashboardStatsRoute()) return;
        const isAssetView = this.isAssetStatsView();
        const stats = this.props.dashboardReducer?.getDashboard;
        if (!!stats?.is_asset_dashboard_view === isAssetView) {
            this.statsPanelRequestedMode = null;
            return;
        }
        if (this.statsPanelRequestedMode === isAssetView) return;
        this.statsPanelRequestedMode = isAssetView;
        this.getSidePanelValues();
    };

    getAssetSidePanelChartParams = () => {
        const storedChartParams = this.props.assetManagementReducer?.chartParams || {};
        const chartParams = storedChartParams.from ? storedChartParams : { ...storedChartParams, from: resolveAssetDashboardFrom(storedChartParams) };
        const assetTableFilters = this.props.assetDashboardReducer?.assetTableFilters || {};
        if (Object.keys(assetTableFilters).length) return { ...chartParams, ...assetTableFilters };
        return getSourceShapedChartParams(chartParams);
    };

    isMobileAssetDashboardView = () =>
        (this.isAssetDashboardRoute() && isMobileAssetDashboard(this.getAssetSidePanelChartParams())) ||
        (!this.isDashboardStatsRoute() && !this.isFcaDashboardRoute() && isMobileAssetDefaultDashboard());

    getSidePanelValues = async () => {
        if (this.isAssetStatsView()) {
            await this.props.getDashboard(
                getAssetDashboardSidePanelParams(this.props.dashboardReducer, {
                    assetClient: this.getAssetDashboardClient(),
                    chartParams: this.getAssetSidePanelChartParams()
                }),
                true
            );
            return;
        }

        const sessionProjectId = await resolveSessionDefaultProject({
            getUserById: this.props.getUserById,
            updateDefaultProject: this.props.updateDefaultProject,
            reduxDefaultProject: this.props.dashboardReducer?.defaultProject
        });

        let dashboardFilterParams = {
            chart_type: this.props.dashboardReducer.individualFilters?.chart_type || "categories",
            fci_type: this.props.dashboardReducer.individualFilters?.fci_type || "regions",
            display: this.props.dashboardReducer.individualFilters?.display || "region",
            horizontal_chart_type: this.props.dashboardReducer.individualFilters?.horizontal_chart_type || "categories",
            map_type: this.props.dashboardReducer.individualFilters?.map_type || "site",
            map_mode: this.props.dashboardReducer.individualFilters?.map_mode || "silver",
            chart_sort_by: this.props.dashboardReducer.individualFilters?.chart_sort_by || "value",
            chart_sort_order: this.props.dashboardReducer.individualFilters?.chart_sort_order || null,
            fci_sort_by: this.props.dashboardReducer.individualFilters?.fci_sort_by || "value",
            fci_sort_order: this.props.dashboardReducer.individualFilters?.fci_sort_order || null
        };
        await this.props.getDashboard(
            buildDashboardReportParams(dashboardFilterParams, {
                masterBuildingTypes: this.props.dashboardReducer?.masterFilterList?.building_types || [],
                sessionDefaultProjectId: getSessionDefaultProjectId(sessionProjectId)
            })
        );
    };

    // closeNav = () => {
    //     var element = document.getElementById("sidebar");
    //     var element1 = document.getElementById("main");
    //     this.props.handleShowNa();
    //     if(this.props.match.path == '/dashboard'){
    //         this.setState({
    //             isDashboardClick:!this.state.isDashboardClick
    //         })
    //     }
    //     element.style.width = "30px";
    //     element1.style.marginLeft = "30px";
    //     element.classList.add("expandnavbar");
    //     element1.classList.add("expandnavbarr");
    //     element1.classList.remove("margin-nav");
    // };

    // showNav = () => {
    //     var element = document.getElementById("sidebar");
    //     var element1 = document.getElementById("main");
    //     this.props.handleShowNa();
    //     element.style.width = "300px";
    //     element1.style.marginLeft = "300px";
    //     element.classList.remove("expandnavbar");
    //     element1.classList.remove("expandnavbarr");
    //     element1.classList.add("margin-nav");
    // };

    refreshPublishedDynamicTables = () => {
        const projectId = getSessionDefaultProjectId(this.props.dashboardReducer?.defaultProject);
        this.props.getPublishedDynamicTables(projectId ? { project_id: projectId } : {});
    };

    resolveFlyoutMenuNodes = (currentNodes, ...fallbackSources) => {
        if (currentNodes?.length) {
            return currentNodes;
        }

        for (const source of fallbackSources) {
            if (source?.length) {
                return source;
            }
        }

        return [];
    };

    shouldUpdateFlyoutMenuNodes = (existingNodes = [], incomingNodes = []) => {
        if (!incomingNodes?.length) {
            return false;
        }

        return (existingNodes || []).length !== incomingNodes.length;
    };

    setMenuData = () => {
        const {
            commonReducer: { getMenuItemsResponse, getProjectMenuItemsResponse, getEfciMenuItemsResponse }
        } = this.props;
        const currentMenuData = this?.state?.menuData;
        let projectMenuNodes = this.resolveFlyoutMenuNodes(
            currentMenuData?.find(m => m.key === "projects")?.nodes,
            getProjectMenuItemsResponse?.projects,
            getMenuItemsResponse?.projects
        );
        let efciMenuNodes = this.resolveFlyoutMenuNodes(
            currentMenuData?.find(m => m.key === "efci")?.nodes,
            getEfciMenuItemsResponse?.efcis,
            getMenuItemsResponse?.efcis
        );
        const assetClient = (localStorage.getItem("asset_management_client") && JSON.parse(localStorage.getItem("asset_management_client"))) || {};
        const energyClient = (localStorage.getItem("energy_management_client") && JSON.parse(localStorage.getItem("energy_management_client"))) || {};
        let user_role = localStorage.getItem("role");
        let assetManagementBC = assetClient?.id
            ? [
                  { key: "main", name: "Asset Management", path: "/assetmanagement" },
                  {
                      key: "assetName",
                      name: assetClient?.name,
                      path: `/assetmanagement/assetinfo/${assetClient?.id}/basicdetails`
                  },
                  {
                      key: "info",
                      name: "Assets",
                      path: `/assetmanagement/assetinfo/${assetClient?.id}/assets?parentSection=asset`
                  }
              ]
            : [{ key: "main", name: "Asset Management", path: "/assetmanagement" }];

        let energyManagementBC = energyClient?.id
            ? [
                  { key: "main", name: "Energy Management", path: "/energyManagement" },
                  {
                      key: "energyName",
                      name: energyClient?.name,
                      path: `/energymanagement/energyinfo/${energyClient.id}/basicdetails`
                  },
                  {
                      key: "info",
                      name: "Charts & Graphs",
                      path: `/energymanagement/energyinfo/${energyClient.id}/energydashboard`
                  }
              ]
            : [{ key: "main", name: "Energy Management", path: "/energyManagement" }];
        let hasLandingPage = localStorage.getItem("hasLandingPage") === "true" ? true : false;
        const publishedDynamicTables = this.state?.publishedDynamicTables || [];
        let tempMenuData = [
            {
                key: "landing-page",
                label: "Landing Page",
                url: "home",
                nodes: [],
                view: hasLandingPage,
                icon: "/img/landing-menu.svg",
                bc: [{ key: "main", name: "Home", path: "/home" }]
            },
            {
                key: "projects",
                name: "projects",
                label: "FCA Projects",
                url: "Project",
                view: checkPermission("menu", "fca_projects", null),
                icon: "/img/project-menu.svg",
                isExpandable: true,
                bc: [{ key: "main", name: "FCA Projects", path: "/project" }],
                nodes: projectMenuNodes,
                view_info: checkPermission("forms", "fca_projects", "view"),
                isQuickLink: true,
                permissionKeys: ["menu", "fca_projects", null]
            },
            {
                key: "smartCharts",
                label: "Smart Reports & Charts",
                url: "smartcharts/reports",
                view: checkPermission("menu", permissions.SMART_CHARTS, null),
                icon: "/img/smartchart-menu.svg",
                bc: [
                    { key: "main", name: "Smart Reports & Charts", path: "/smartcharts/reports" },
                    { key: "reports", name: "Reports", path: "/smartcharts/reports" }
                ],
                nodes: [],
                view_info: checkPermission("forms", permissions.SMART_CHARTS, "view"),
                isQuickLink: true,
                permissionKeys: ["menu", permissions.SMART_CHARTS, null]
            },
            {
                key: "efci",
                label: "EFCI Benchmarking",
                url: "Efci",
                name: "efcis",
                view: checkPermission("menu", "efci_benchmarking", null),
                icon: "/img/efci-menu.svg",
                isExpandable: true,
                bc: [{ key: "main", name: "EFCI", path: "/efci" }],
                nodes: efciMenuNodes,
                view_info: checkPermission("forms", "fca_projects", "view"),
                isQuickLink: true,
                permissionKeys: ["menu", "efci_benchmarking", null]
            },
            {
                key: "energyManagement",
                label: "Energy Management",
                url: energyClient?.id ? `energymanagement/energyinfo/${energyClient.id}/energydashboard` : "energyManagement",
                view: checkPermission("menu", "energy_management", null),
                icon: "/img/energy-menu.svg",
                bc: energyManagementBC,
                view_info: checkPermission("forms", "meter_readings", "view"),
                isQuickLink: true,
                permissionKeys: ["menu", "energy_management", null],
                baseUrl: "energyManagement"
            },
            {
                key: "assetmanagement",
                label: "Asset Management",
                url: assetClient?.id ? `assetmanagement/assetinfo/${assetClient.id}/assets` : "assetmanagement",
                view: checkPermission("menu", "asset_management", null),
                icon: "/img/asset-menu.svg",
                bc: assetManagementBC,
                view_info: checkPermission("forms", "asset_management", "view"),
                isQuickLink: true,
                permissionKeys: ["menu", "asset_management", null],
                baseUrl: "assetmanagement"
            },
            {
                key: "clientDynamicTables",
                label: "Client Dynamic Tables",
                url: "client-dynamic-tables",
                view: checkPermission("menu", permissions.CLIENT_DYNAMIC_TABLES, null) && publishedDynamicTables.length > 0,
                icon: "/img/document-menu.svg",
                bc: [{ key: "main", name: "Client Dynamic Tables", path: CLIENT_DYNAMIC_TABLES_PATH }],
                view_info: true,
                isQuickLink: true,
                permissionKeys: ["menu", permissions.CLIENT_DYNAMIC_TABLES, null],
                baseUrl: "client-dynamic-tables"
            },
            {
                key: "mobile-solutions",
                label: "Mobile Solutions",
                url: null,
                view: checkPermission("menu", "mobile_solution", null),
                icon: "/img/mobile-menu.svg",
                bc: [{ key: "main", name: "Mobile Solutions", path: "/asset-survey-project" }],
                nodes: [
                    {
                        key: "assetSurveyProject",
                        label: "Asset Survey Projects",
                        url: "asset-survey-project",
                        view: checkPermission("menu", "mobile_solution", "asset_survey_project"),
                        bc: [
                            { key: "main", name: "Mobile Solutions", path: "/asset-survey-project" },
                            { key: "survey-projects", name: "Asset Survey Projects", path: "/asset-survey-project" }
                        ],
                        view_info: checkPermission("forms", "asset_survey_project", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "mobile_solution", "asset_survey_project"]
                    },
                    {
                        key: "survey-template",
                        label: "Asset Survey Templates",
                        url: "survey-template",
                        view: checkPermission("menu", "mobile_solution", "asset_survey_template"),
                        bc: [
                            { key: "main", name: "Mobile Solutions", path: "/survey-template" },
                            { key: "survey-templates", name: "Asset Survey Templates", path: "/survey-template" }
                        ],
                        view_info: checkPermission("forms", "asset_survey_template", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "mobile_solution", "asset_survey_template"]
                    },
                    {
                        key: "project-template",
                        label: "FCA Survey Projects",
                        url: "project-template",
                        view: checkPermission("menu", "mobile_solution", "fca_survey_project"),
                        bc: [
                            { key: "main", name: "Mobile Solutions", path: "/project-template" },
                            { key: "project-templates", name: "FCA Survey Projects", path: "/project-template" }
                        ],
                        view_info: checkPermission("forms", "fca_survey_project", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "mobile_solution", "fca_survey_project"]
                    },
                    {
                        key: "global-project-template",
                        label: "FCA Survey Templates",
                        url: "global-project-template",
                        view: checkPermission("menu", "mobile_solution", "fca_survey_template"),
                        bc: [
                            { key: "main", name: "Mobile Solutions", path: "/global-project-template" },
                            { key: "global-project-template", name: "FCA Survey Templates", path: "/global-project-template" }
                        ],
                        view_info: checkPermission("forms", "fca_survey_template", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "mobile_solution", "fca_survey_template"]
                    },
                    {
                        key: "survey-settings",
                        label: "Image & Sync Settings",
                        url: "survey-settings",
                        view: checkPermission("menu", "mobile_solution", "image_and_sync_settings"),
                        bc: [
                            { key: "main", name: "Mobile Solutions", path: "/survey-settings" },
                            { key: "survey-settings", name: "Image & Sync Settings", path: "/survey-settings" }
                        ],
                        view_info: checkPermission("menu", "mobile_solution", "image_and_sync_settings"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "mobile_solution", "image_and_sync_settings"]
                    },
                    {
                        key: "surveyor-profiles",
                        label: "Surveyor Profiles",
                        url: "surveyor-profiles",
                        view: checkPermission("menu", "mobile_solution", "surveyor_profile"),
                        bc: [
                            { key: "main", name: "Mobile Solutions", path: "/surveyor-profiles" },
                            { key: "surveyor-profiles", name: "Surveyor Profiles", path: "/surveyor-profiles" }
                        ],
                        view_info: checkPermission("forms", "surveyor_profile", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "mobile_solution", "surveyor_profile"]
                    }
                ]
            },
            {
                key: "images",
                label: "Image Management",
                url: "images",
                view: checkPermission("menu", "image_management", null),
                icon: "/img/image-menu.svg",
                bc: [{ key: "main", name: "Image Management", path: "/images" }],
                view_info: checkPermission("forms", "image_management", "view"),
                isQuickLink: true,
                permissionKeys: ["menu", "image_management", null]
            },
            {
                key: "initiatives",
                label: "Project Initiatives",
                url: "Initiatives",
                view: checkPermission("menu", "initiatives", null),
                icon: "/img/initiative-menu.svg",
                bc: [{ key: "main", name: "Project Initiatives", path: "/Initiatives" }],
                view_info: checkPermission("forms", "initiatives", "view"),
                isQuickLink: true,
                permissionKeys: ["menu", "initiatives", null]
            },
            {
                key: "documents",
                label: "Document Management",
                url: "documents",
                view: checkPermission("menu", "documents", null),
                icon: "/img/document-menu.svg",
                bc: [{ key: "main", name: "Document Management", path: "/documents" }],
                view_info: checkPermission("forms", "documents", "view"),
                isQuickLink: true,
                permissionKeys: ["menu", "documents", null],
                hasDivider: true
            },
            {
                key: "project_settings",
                label: "Project Settings",
                url: null,
                view: checkPermission("menu", permissions.PROJECT_SETTINGS, null),
                icon: "/img/project-settings-menu.svg",
                bc: [{ key: "main", name: "Project Settings", path: "/project_settings" }],
                nodes: [
                    {
                        key: "local-project-settings-template",
                        label: "Project Settings Template",
                        url: "local-project-settings-template",
                        view: checkPermission("menu", permissions.PROJECT_SETTINGS, permissions.PROJECT_SETTINGS_TEMPLATE),
                        bc: [{ key: "local-project-settings-template", name: "Project Settings Template", path: "/local-project-settings-template" }],
                        view_info: checkPermission("forms", permissions.PROJECT_SETTINGS_TEMPLATE, "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", permissions.PROJECT_SETTINGS, permissions.PROJECT_SETTINGS_TEMPLATE]
                    },
                    {
                        key: "master-project-settings-template",
                        label: "Master Global Project Settings",
                        url: "master-project-settings-template",
                        view: checkPermission("menu", permissions.PROJECT_SETTINGS, permissions.MASTER_PROJECT_SETTINGS_TEMPLATE),
                        bc: [
                            {
                                key: "master-project-settings-template",
                                name: "Master Global Project Settings",
                                path: "/master-project-settings-template",
                                disabled: true
                            }
                        ],
                        view_info: checkPermission("forms", permissions.MASTER_PROJECT_SETTINGS_TEMPLATE, "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", permissions.PROJECT_SETTINGS, permissions.MASTER_PROJECT_SETTINGS_TEMPLATE]
                    }
                ]
            },
            {
                key: "energyManagementSettings",
                label: "Energy Settings",
                url: null,
                view: checkPermission("menu", "energy_management_settings", null),
                icon: "/img/energy-settings-menu.svg",
                bc: [{ key: "main", name: "Energy Management", path: "/accounts" }],
                nodes: [
                    {
                        key: "accounts",
                        label: "Accounts",
                        url: "accounts",
                        view: checkPermission("menu", "energy_management_settings", "accounts"),
                        bc: [{ key: "accounts", name: "Accounts", path: "/accounts" }],
                        view_info: checkPermission("forms", "accounts", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "energy_management_settings", "accounts"]
                    },
                    {
                        key: "meter",
                        label: "Meter",
                        url: "meter",
                        view: checkPermission("menu", "energy_management_settings", "meter"),
                        bc: [{ key: "meter", name: "Meter", path: "/meter" }],
                        view_info: checkPermission("forms", "meters", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "energy_management_settings", "meter"]
                    },
                    {
                        key: "median",
                        label: "Property Type Median EUIs (US)",
                        url: "median",
                        view: checkPermission("menu", "energy_management_settings", "median"),
                        bc: [{ key: "median", name: "Property Type Median EUIs (US)", path: "/median" }],
                        view_info: checkPermission("forms", "median", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "energy_management_settings", "median"]
                    }
                ]
            },
            {
                key: "assetSettings",
                label: "Asset Settings",
                url: null,
                view: checkPermission("menu", "asset_settings", null),
                icon: "/img/asset-settings-menu.svg",
                bc: [{ key: "main", name: "Asset Settings", path: null }],
                nodes: Object.keys(AssetSettingsEntities)
                    .filter(key => !AssetSettingsEntities?.[key]?.isNotSideMenu)
                    .map((key, index) => ({
                        key: key,
                        label: AssetSettingsEntities[key].name,
                        url: `asset-settings/${key}`,
                        view: checkPermission("menu", "asset_settings", AssetSettingsEntities[key].permissionKey),
                        bc: [
                            {
                                key: key,
                                name: AssetSettingsEntities[key].name,
                                path: `/asset-settings/${key}`
                            }
                        ],
                        view_info: checkPermission("forms", AssetSettingsEntities[key].permissionKey, "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "asset_settings", AssetSettingsEntities[key].permissionKey]
                    }))
            },
            {
                key: "documentSetting",
                label: "Document Settings",
                url: null,
                view: checkPermission("menu", "document_settings", null),
                icon: "/img/document-settings-menu.svg",
                bc: [{ key: "main", name: "Document Settings", path: null }],
                nodes: Object.keys(DocumentSettingsEntities).map((key, index) => ({
                    key: key,
                    label: DocumentSettingsEntities[key].name,
                    url: `document-settings/${key}`,
                    view: checkPermission("menu", "document_settings", DocumentSettingsEntities[key].permissionKey),
                    bc: [
                        {
                            key: key,
                            name: DocumentSettingsEntities[key].name,
                            path: `/document-settings/${key}`
                        }
                    ],
                    view_info: checkPermission("forms", DocumentSettingsEntities[key].permissionKey, "view"),
                    isQuickLink: true,
                    permissionKeys: ["menu", "document_settings", DocumentSettingsEntities[key].permissionKey]
                }))
            },
            {
                key: "reportsettings",
                label: "Report Settings",
                url: null,
                view: checkPermission("menu", "report_settings", null),
                icon: "/img/report-settings-menu.svg",
                bc: [{ key: "main", name: "Report Settings", path: "/trade" }],
                nodes: [
                    {
                        key: "reportPropertyValues",
                        label: "Property Values",
                        url: "settings/reportpropertyvalues/fontnames",
                        view: checkPermission("menu", "report_settings", "report_properties"),
                        bc: [
                            {
                                key: "reportPropertyValues",
                                name: "Property Values",
                                path: "/settings/reportpropertyvalues/fontnames"
                            }
                        ],
                        view_info: checkPermission("forms", "global_report_properties", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "report_settings", "report_properties"]
                    },
                    {
                        key: "chartProperties",
                        label: "Export Properties",
                        url: "chartProperties",
                        view: checkPermission("menu", "report_settings", "report_properties"),
                        bc: [
                            {
                                key: "chartProperties",
                                name: "Export Properties",
                                path: "/chartProperties"
                            }
                        ],
                        view_info: checkPermission("forms", "global_chart_properties", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "report_settings", "report_properties"]
                    },
                    {
                        key: "chartTemplates",
                        label: "Export Templates",
                        url: "chartTemplates",
                        view: checkPermission("menu", "report_settings", "report_templates"),
                        bc: [
                            {
                                key: "chartTemplates",
                                name: "Export Templates",
                                path: "/chartTemplates"
                            }
                        ],
                        view_info: checkPermission("forms", "global_chart_templates", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "report_settings", "report_templates"]
                    }
                ]
            },
            {
                key: "settings",
                label: "General Settings",
                url: null,
                view: checkPermission("menu", "settings", null),
                icon: "/img/general-settings-menu.svg",
                bc: [{ key: "main", name: "Settings", path: "/settings/buildingtype" }],
                nodes: [
                    {
                        key: "task-manager",
                        label: "Task Manager",
                        url: "task-manager",
                        name: "task-manager",
                        view: checkPermission("menu", "settings", "task-manager"),
                        bc: [
                            {
                                key: "task-manager",
                                name: "Task Manager",
                                path: "/task-manager"
                            }
                        ],
                        view_info: checkPermission("menu", "settings", "task-manager"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", "task-manager"]
                    },
                    {
                        key: "consultancy",
                        label: "Consultancies",
                        url: "Consultancy",
                        name: "consultancies",
                        view: checkPermission("menu", "settings", "consultancies"),
                        bc: [
                            {
                                key: "consultancy",
                                name: "Consultancy",
                                path: "/Consultancy"
                            }
                        ],
                        nodes: getMenuItemsResponse && getMenuItemsResponse.consultancies ? getMenuItemsResponse.consultancies : [],
                        view_info: checkPermission("forms", "consultancies", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", "consultancies"]
                    },
                    {
                        key: "client",
                        label: "Clients",
                        url: "Client",
                        name: "clients",
                        view: checkPermission("menu", "settings", "clients"),
                        bc: [
                            {
                                key: "client",
                                name: "Clients",
                                path: "/Client"
                            }
                        ],
                        nodes: getMenuItemsResponse && getMenuItemsResponse.clients ? getMenuItemsResponse.clients : [],
                        view_info: checkPermission("forms", "clients", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", "clients"]
                    },
                    {
                        key: "region",
                        label: "Regions",
                        url: "Region",
                        name: "regions",
                        view: checkPermission("menu", "settings", "regions"),
                        bc: [
                            {
                                key: "region",
                                name: "Regions",
                                path: "/Region"
                            }
                        ],
                        nodes: getMenuItemsResponse && getMenuItemsResponse.regions ? getMenuItemsResponse.regions : [],
                        view_info: checkPermission("forms", "regions", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", "regions"]
                    },
                    {
                        key: "site",
                        label: "Sites",
                        url: "site",
                        name: "sites",
                        view: checkPermission("menu", "settings", "sites"),
                        bc: [
                            { key: "main", name: "General Settings", path: "/Site" },
                            {
                                key: "site",
                                name: "Sites",
                                path: "/Site"
                            }
                        ],
                        nodes: getMenuItemsResponse && getMenuItemsResponse.sites ? getMenuItemsResponse.sites : [],
                        view_info: checkPermission("forms", "sites", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", "sites"]
                    },
                    {
                        key: "building",
                        label: "Buildings",
                        url: "Building",
                        name: "buildings",
                        view: checkPermission("menu", "settings", "buildings"),
                        bc: [
                            { key: "main", name: "General Settings", path: "/Building" },
                            {
                                key: "building",
                                name: "Buildings",
                                path: "/building"
                            }
                        ],
                        nodes: getMenuItemsResponse && getMenuItemsResponse.buildings ? getMenuItemsResponse.buildings : [],
                        view_info: checkPermission("forms", "buildings", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", "buildings"]
                    },
                    {
                        key: "buildingtype",
                        label: "Building Type",
                        url: "settings/buildingtype",
                        view: checkPermission("menu", "settings", "building_type"),
                        bc: [
                            {
                                key: "buildingTypeName",
                                name: "Building Type",
                                path: "/settings/buildingtype"
                            }
                        ],
                        view_info: checkPermission("forms", "building_types", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", "building_type"]
                    },
                    {
                        key: "tradeGeneral",
                        label: "Trade",
                        url: "trade?general=true",
                        view: checkPermission("menu", "settings", "trade"),
                        bc: [
                            {
                                key: "trade",
                                name: "Trade",
                                path: "/trade?general=true"
                            }
                        ],
                        view_info: checkPermission("forms", "master_trades", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", "trade"]
                    },
                    {
                        key: "systemGeneral",
                        label: "System",
                        url: "system?general=true",
                        view: checkPermission("menu", "settings", "system"),
                        bc: [
                            {
                                key: "system",
                                name: "System",
                                path: "/system?general=true"
                            }
                        ],
                        view_info: checkPermission("forms", "master_systems", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", "system"]
                    },
                    {
                        key: "subsystemGeneral",
                        label: "Sub System",
                        url: "subsystem?general=true",
                        view: checkPermission("menu", "settings", "sub_system"),
                        bc: [
                            {
                                key: "subsystem",
                                name: "Sub System",
                                path: "/subsystem?general=true"
                            }
                        ],
                        view_info: checkPermission("forms", "master_sub_systems", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", "sub_system"]
                    },
                    {
                        key: "reportnotetemplate",
                        label: "Recommendation Narrative Template",
                        url: "reportnotetemplate",
                        view: checkPermission("menu", "settings", "narrative_template"),
                        bc: [
                            {
                                key: "reportnotetemplate",
                                name: "Recommendation Narrative Template",
                                path: "/reportnotetemplate"
                            }
                        ],
                        view_info: checkPermission("forms", "report_note_templates", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", "narrative_template"]
                    },
                    {
                        key: "user",
                        label: "Users",
                        url: "settings/user",
                        view: checkPermission("menu", "settings", "users"),
                        bc: [
                            {
                                key: "userName",
                                name: "User",
                                path: "/settings/user"
                            }
                        ],
                        view_info: checkPermission("forms", "users", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", "users"]
                    },
                    {
                        key: "userPermissions",
                        label: "User Permissions",
                        url: "settings/userPermissions",
                        view: checkPermission("menu", "settings", "user_permissions"),
                        bc: [
                            {
                                key: "userName",
                                name: "User Permissions",
                                path: "/settings/userPermissions"
                            }
                        ],
                        view_info: checkPermission("forms", "user_permissions", "view"),
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", "user_permissions"]
                    },
                    {
                        key: "templates",
                        label: "Templates",
                        view: checkPermission("menu", "settings", "templates"),
                        url: "settings/templates",
                        bc: [
                            {
                                key: "templates",
                                name: "Templates",
                                path: "/settings/templates"
                            }
                        ],
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", "templates"]
                    },
                    {
                        key: "helpers",
                        label: "Helpers",
                        view: checkPermission("menu", "settings", "page_infos"),
                        url: "settings/helpers",
                        bc: [
                            {
                                key: "helpers",
                                name: "Helpers",
                                path: "/settings/helpers"
                            }
                        ],
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", "page_infos"]
                    },
                    {
                        key: "recommendationDynamicField",
                        label: "Dynamic Fields",
                        view: checkPermission("menu", "settings", permissions.DYNAMIC_FIELDS),
                        url: "dynamic-field-settings/recommendationdynamicfield",
                        bc: [
                            {
                                key: "recommendationdynamicfield",
                                name: "Recommendation Dynamic Fields",
                                path: `/dynamic-field-settings/recommendationdynamicfield`
                            }
                        ],
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", permissions.DYNAMIC_FIELDS]
                    },
                    {
                        key: "dynamicTables",
                        label: "Dynamic Tables",
                        view: checkPermission("menu", "settings", permissions.DYNAMIC_TABLES),
                        url: "dynamic-tables",
                        bc: [
                            {
                                key: "dynamicTables",
                                name: "Dynamic Tables",
                                path: "/dynamic-tables"
                            }
                        ],
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", permissions.DYNAMIC_TABLES]
                    },
                    {
                        key: "asset_dynamic_dictionary",
                        label: AssetSettingsEntities?.asset_dynamic_dictionary.name,
                        view: checkPermission("menu", "settings", AssetSettingsEntities?.asset_dynamic_dictionary?.permissionKey),
                        url: `asset-settings/asset_dynamic_dictionary`,
                        bc: [
                            {
                                key: "asset_dynamic_dictionary",
                                name: AssetSettingsEntities?.asset_dynamic_dictionary.name,
                                path: `/asset-settings/asset_dynamic_dictionary`
                            }
                        ],
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", AssetSettingsEntities?.asset_dynamic_dictionary?.permissionKey]
                    },
                    {
                        key: "manageLandingPage",
                        label: "Manage Landing Page",
                        view: checkPermission("menu", "settings", "landing_pages"),
                        url: "settings/manageLandingPage",
                        bc: [
                            {
                                key: "manageLandingPage",
                                name: "Manage Landing Page",
                                path: "/settings/manageLandingPage"
                            }
                        ],
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", "landing_pages"]
                    },
                    {
                        key: "manageHeadings",
                        label: "Manage Headings",
                        view: checkPermission("menu", "settings", "manage_headings"),
                        url: "settings/manageHeadings",
                        bc: [
                            {
                                key: "manageHeadings",
                                name: "Manage Headings",
                                path: "/settings/manageHeadings"
                            }
                        ],
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", "manage_headings"]
                    },
                    {
                        key: "email",
                        label: "Emails",
                        view: checkPermission("menu", "settings", "email"),
                        url: "settings/email",
                        bc: [
                            {
                                key: "email",
                                name: "Email",
                                path: "/settings/email"
                            }
                        ],
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", "email"]
                    },
                    {
                        key: "notifications",
                        label: "Notifications",
                        view: checkPermission("menu", "settings", "notifications"),
                        url: "settings/notifications",
                        bc: [
                            {
                                key: "notifications",
                                name: "Notifications",
                                path: "/settings/notifications"
                            }
                        ],
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", "notifications"]
                    },
                    {
                        key: "logs",
                        label: "Logs",
                        view: checkPermission("menu", "settings", "user_activity_logs"),
                        url: "settings/logs",
                        bc: [
                            {
                                key: "logs",
                                name: "Logs",
                                path: "/settings/logs"
                            }
                        ],
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", "user_activity_logs"]
                    },
                    {
                        // Active Sessions is Super Admin only (mirrors the /settings/active-sessions route
                        // gate) AND behind the `active_sessions_page` FME flag, so the entry is absent
                        // entirely until the flag is created and turned on. There is no active_sessions
                        // permission key, so the role is checked directly as AI Settings does. FCA-6979.
                        key: "activeSessions",
                        label: "Active Sessions",
                        url: "settings/active-sessions",
                        name: "active-sessions",
                        view: user_role === "super_admin" && isEnabled(ACTIVE_SESSIONS_FLAG),
                        bc: [
                            {
                                key: "activeSessions",
                                name: "Active Sessions",
                                path: "/settings/active-sessions"
                            }
                        ],
                        view_info: true,
                        isQuickLink: true,
                        permissionKeys: ["menu", "settings", "active_sessions"]
                    }
                ]
            },
            {
                key: "aiSettings",
                label: "AI Settings",
                url: null,
                // Every page under AI Settings is owned by Otto's backend (filter-ai) and gated by Otto's
                // OWN permission system, not the app's: super_admins always see it, and anyone else sees
                // only what they were granted on /settings/otto-permissions. That is why these use
                // canUseOttoPage instead of checkPermission — there is no ai_settings key in the Ruby
                // permission blob, and deliberately so (Otto's access never touches the `groups` model).
                // Each `view` must mirror the matching route's `ottoPage` gate in App.js, or the menu
                // offers a link that lands on PageNotFound.
                view: canSeeAiSettings(),
                icon: "/img/general-settings-menu.svg",
                bc: [{ key: "main", name: "AI Settings", path: "/settings/knowledge" }],
                nodes: [
                    {
                        key: "knowledgeBase",
                        label: "Knowledge Base",
                        url: "settings/knowledge",
                        view: canUseOttoPage(OTTO_PAGES.KNOWLEDGE_BASE),
                        bc: [
                            {
                                key: "knowledgeBase",
                                name: "Knowledge Base",
                                path: "/settings/knowledge"
                            }
                        ],
                        view_info: true,
                        isQuickLink: true,
                        permissionKeys: ["menu", "ai_settings", "knowledge_base"]
                    },
                    {
                        // Asset model/manufacturer template curation. It sits under AI Settings because its
                        // API and its assets_templates table are owned by the same backend (filter-ai) and it
                        // carries the identical gate — not because it is an AI feature. Placing it under
                        // General Settings instead would need a new key in permissions.js.
                        key: "assetModelTemplates",
                        label: "Asset Model Templates",
                        url: "settings/asset-model-templates",
                        view: canUseOttoPage(OTTO_PAGES.ASSET_MODEL_TEMPLATES),
                        bc: [
                            {
                                key: "assetModelTemplates",
                                name: "Asset Model Templates",
                                path: "/settings/asset-model-templates"
                            }
                        ],
                        view_info: true,
                        isQuickLink: true,
                        permissionKeys: ["menu", "ai_settings", "asset_model_templates"]
                    },
                    {
                        // QA/QC anomaly analysis over a project's recommendations. It sits under AI Settings
                        // because the detection is an LLM pass owned by filter-ai, and its findings live in
                        // filter-ai's own table — NOT in Ruby's `recommendation_reviews`, which is what a
                        // recommendation's own QA/QC tab writes to.
                        key: "qaQc",
                        label: "QA/QC",
                        url: "settings/qa-qc",
                        view: canUseOttoPage(OTTO_PAGES.QA_QC),
                        bc: [
                            {
                                key: "qaQc",
                                name: "QA/QC",
                                path: "/settings/qa-qc"
                            }
                        ],
                        view_info: true,
                        isQuickLink: true,
                        permissionKeys: ["menu", "ai_settings", "qa_qc"]
                    },
                    {
                        // Otto's readings of photographs from the image library - objects, setting and visible
                        // deficiencies - saved against each photo in filter-ai's own table. The grid is Image
                        // Management's; see src/components/imageAnalysis/ImageAnalysisPage.jsx.
                        key: "imageAnalysis",
                        label: "Image Analyse",
                        url: "settings/image-analysis",
                        view: canUseOttoPage(OTTO_PAGES.IMAGE_ANALYSIS),
                        bc: [
                            {
                                key: "imageAnalysis",
                                name: "Image Analyse",
                                path: "/settings/image-analysis"
                            }
                        ],
                        view_info: true,
                        isQuickLink: true,
                        permissionKeys: ["menu", "ai_settings", "image_analysis"]
                    },
                    {
                        // Who may use Otto. The page that grants every other entry in this category —
                        // including itself, so access to it can be delegated without a super_admin.
                        key: "ottoPermissions",
                        label: "Otto User Permissions",
                        url: "settings/otto-permissions",
                        view: canUseOttoPage(OTTO_PAGES.PERMISSIONS),
                        bc: [
                            {
                                key: "ottoPermissions",
                                name: "Otto User Permissions",
                                path: "/settings/otto-permissions"
                            }
                        ],
                        view_info: true,
                        isQuickLink: true,
                        permissionKeys: ["menu", "ai_settings", "otto_permissions"]
                    }
                ]
            }
        ];
        this.setState({
            menuData: tempMenuData
        });
    };

    setBreadCrumpData = async pageData => {
        bulkResetBreadCrumpData(pageData.bc);
        return true;
    };

    setDynamicUrl = (url = null) => {
        switch (url) {
            case "narrativetemplate":
                localStorage.setItem("dynamicUrl", `/narrative_templates`);
                break;
            case "tabletemplate":
                localStorage.setItem("dynamicUrl", `/table_templates`);
                break;
            case "reportnotetemplate":
                localStorage.setItem("dynamicUrl", `/report_note_templates`);
                break;
            case "specialreport":
                localStorage.setItem("dynamicUrl", `/special_reports`);
                break;
            case "reportparagraph":
                localStorage.setItem("dynamicUrl", `/report_paragraphs`);
                break;
            case "childparagraph":
                localStorage.setItem("dynamicUrl", `/child_paragraphs`);
                break;
            case "chartsandgraphs":
                localStorage.setItem("dynamicUrl", `/charts_and_graphs`);
                break;
            case "systemtables":
                localStorage.setItem("dynamicUrl", `/system_tables`);
                break;
            default:
                break;
        }
    };

    handleClick = async data => {
        const { history } = this.props;
        this.setDynamicUrl(data.url);
        await this.props.savePopUpData({});
        if (data.url && data.view_info !== false) {
            await this.setBreadCrumpData(data);
            if (data.url) history.push(`/${data.url}`);
        }
    };

    handleSideNavClick = (props, level, onNavigated = null, parentItem = null) => {
        if (props?.key === "landing-page") {
            this.setState({ showGotoLandingConfirmModal: true });
            return false;
        }
        const action = async () => {
            if (props?.key === "energy_management") {
                let energyClient =
                    (localStorage.getItem("energy_management_client") && JSON.parse(localStorage.getItem("energy_management_client"))) || {};
                energyClient?.id && localStorage.setItem("energyclientID", energyClient?.id);
            }

            if (this.props.match.path !== "/dashboard") {
                this.setState({
                    redirection: false
                });
            }
            sessionStorage.removeItem("selectedProperty");
            this.handleClick({
                url: props.url,
                bc: props.bc,
                label: props.label,
                level: level,
                view_info: props.view_info
            });
            if (onNavigated) onNavigated?.();
            const default_project = localStorage.getItem("default_project");
            if (
                (props?.entity === "FCA Project" || parentItem?.entity === "FCA Project") &&
                default_project !== (parentItem?.key ?? props?.key) &&
                (parentItem?.key || props?.key) &&
                checkPermission("forms", "users", "edit")
            ) {
                const userId = localStorage.getItem("userId");
                await this.props.updateUser(
                    {
                        default_project_id: parentItem?.key ?? props?.key,
                        assetmanagement_client_id: parentItem?.client_id ?? props?.client_id,
                        energymanagement_client_id: parentItem?.client_id ?? props?.client_id
                    },
                    userId
                );
                if (store.getState().userReducer?.updateUserResponse?.success) {
                    await this.props?.resetImageEntityParams();
                    await this.props?.getUserById(userId);
                    const { assetmanagement_client_id, energymanagement_client_id } = store.getState().userReducer?.getUserByIdResponse || {};
                    const sessionClient = assetmanagement_client_id || energymanagement_client_id;
                    if (sessionClient) {
                        setSessionDefaultClients(sessionClient);
                    }
                    await this.props?.updateDefaultProject(parentItem?.key ?? props?.key, true);
                }
            }
        };

        navigateWithPrompts({
            isFormDirty: this.props.commonReducer.isFormDirty,
            navigateAction: action
        });
    };

    collapseAllItem = () => {
        this.setState({ collapseAll: !this.state.collapseAll });
    };

    showNav = () => {
        var element = document.getElementById("sidebar");
        var element1 = document.getElementById("main");
        this.props.handleShowNa();
        element.style.width = "270px";
        element1.style.marginLeft = "270px";
        element.classList.remove("expandnavbar");
        element1.classList.remove("expandnavbarr");
        element1.classList.add("margin-nav");
    };

    handleView = async (name, breadcrumbName, value) => {
        const action = () => {
            const { sidePanelValues } = this.state;
            this.setState({
                activeSection: "project"
            });
            if (sidePanelValues && sidePanelValues.project_ids && sidePanelValues.project_ids.length) {
                history.push(`/project/projectinfo/${sidePanelValues.project_ids[0]}/basicdetails`);
                // resetBreadCrumpData({
                //     key: "info",
                //     name: "Basic Details",
                //     path: `/project/projectinfo/${sidePanelValues.project_ids[0]}/basicdetails`
                // });
                let bc = [
                    { key: "dashboard", name: "Dashboard", path: "/dashboard", index: 0 },
                    {
                        key: "projectName",
                        name: sidePanelValues.project_name,
                        path: `/project/projectinfo/${sidePanelValues.project_ids[0]}/basicdetails`,
                        index: 1
                    },
                    {
                        key: "info",
                        name: "Basic Details",
                        path: `/project/projectinfo/${sidePanelValues.project_ids[0]}/basicdetails`,
                        index: 2
                    }
                ];
                bulkResetBreadCrumpData(bc);
            }
        };
        navigateWithPrompts({
            isFormDirty: this.props.commonReducer.isFormDirty,
            navigateAction: action
        });
    };
    handleClientView = async () => {
        const action = () => {
            const { sidePanelValues } = this.state;
            this.setState({
                activeSection: "clients"
            });
            if (sidePanelValues && sidePanelValues?.client_id) {
                let bc = [
                    getDashboardBreadCrumb(this.getActiveDashboardKey()),
                    {
                        key: "assetName",
                        name: sidePanelValues?.client_name,
                        path: `/assetmanagement/assetinfo/${sidePanelValues?.client_id}/basicdetails`,
                        index: 1
                    },
                    {
                        key: "info",
                        name: "Basic Details",
                        path: `/assetmanagement/assetinfo/${sidePanelValues?.client_id}/basicdetails?parentSection=asset`,
                        disabled: false,
                        index: 2
                    }
                ];
                bulkResetBreadCrumpData(bc);
                history.push(`/assetmanagement/assetinfo/${sidePanelValues?.client_id}/basicdetails?parentSection=asset`, {
                    from: "assetDashboard"
                });
            }
        };
        navigateWithPrompts({
            isFormDirty: this.props.commonReducer.isFormDirty,
            navigateAction: action
        });
    };

    handleAdditionsView = async () => {
        const action = () => {
            const { sidePanelValues } = this.state;
            this.setState({
                activeSection: "additions"
            });
            if (sidePanelValues && sidePanelValues.project_ids && sidePanelValues.project_ids.length) {
                history.push(`/project/projectinfo/${sidePanelValues.project_ids[0]}/buildingAddition`);
                let bc = [
                    { key: "dashboard", name: "Dashboard", path: "/dashboard", index: 0 },
                    {
                        key: "projectName",
                        name: sidePanelValues.project_name,
                        path: `/project/projectinfo/${sidePanelValues.project_ids[0]}/basicdetails`,
                        index: 1
                    },
                    {
                        key: "info",
                        name: "Additions",
                        path: `/project/projectinfo/${sidePanelValues.project_ids[0]}/buildingAddition`,
                        index: 2
                    }
                ];
                bulkResetBreadCrumpData(bc);
            }
        };

        navigateWithPrompts({
            isFormDirty: this.props.commonReducer.isFormDirty,
            navigateAction: action
        });
    };

    handleFloorsView = async () => {
        const action = () => {
            const { sidePanelValues } = this.state;
            this.setState({
                activeSection: "floors"
            });
            if (sidePanelValues && sidePanelValues.project_ids && sidePanelValues.project_ids.length) {
                history.push(`/project/projectinfo/${sidePanelValues.project_ids[0]}/floors`);
                let bc = [
                    { key: "dashboard", name: "Dashboard", path: "/dashboard", index: 0 },
                    {
                        key: "projectName",
                        name: sidePanelValues.project_name,
                        path: `/project/projectinfo/${sidePanelValues.project_ids[0]}/basicdetails`,
                        index: 1
                    },
                    {
                        key: "info",
                        name: "Floors",
                        path: `/project/projectinfo/${sidePanelValues.project_ids[0]}/floors`,
                        index: 2
                    }
                ];
                bulkResetBreadCrumpData(bc);
            }
        };

        navigateWithPrompts({
            isFormDirty: this.props.commonReducer.isFormDirty,
            navigateAction: action
        });
    };

    handleBuildingView = async (type = "") => {
        const action = () => {
            const { sidePanelValues } = this.state;
            this.setState({
                activeSection: "building"
            });
            if (type === "client") {
                let bc = [
                    getDashboardBreadCrumb(this.getActiveDashboardKey()),
                    {
                        key: "assetName",
                        name: sidePanelValues?.client_name,
                        path: `/assetmanagement/assetinfo/${sidePanelValues?.client_id}/basicdetails`,
                        index: 1
                    },
                    {
                        key: "info",
                        name: "Buildings",
                        path: `/assetmanagement/assetinfo/${sidePanelValues?.client_id}/buildings?parentSection=asset`,
                        index: 2
                    }
                ];
                bulkResetBreadCrumpData(bc);
                history.push(`/assetmanagement/assetinfo/${sidePanelValues?.client_id}/buildings?parentSection=asset`, {
                    from: "assetDashboard"
                });
            } else {
                history.push(`/project/projectinfo/${sidePanelValues.project_ids[0]}/buildings`);
                let bc = [
                    { key: "dashboard", name: "Dashboard", path: "/dashboard", index: 0 },
                    {
                        key: "projectName",
                        name: sidePanelValues.project_name,
                        path: `/project/projectinfo/${sidePanelValues.project_ids[0]}/basicdetails`,
                        index: 1
                    },
                    { key: "info", name: "Buildings", path: `/project/projectinfo/${sidePanelValues.project_ids[0]}/buildings`, index: 2 }
                ];
                bulkResetBreadCrumpData(bc);
            }
        };
        navigateWithPrompts({
            isFormDirty: this.props.commonReducer.isFormDirty,
            navigateAction: action
        });
    };

    handleSiteView = async (type = "") => {
        const action = () => {
            const { sidePanelValues } = this.state;
            this.setState({
                activeSection: "site"
            });
            if (type === "client") {
                let bc = [
                    getDashboardBreadCrumb(this.getActiveDashboardKey()),
                    {
                        key: "assetName",
                        name: sidePanelValues?.client_name,
                        path: `/assetmanagement/assetinfo/${sidePanelValues?.client_id}/basicdetails`,
                        index: 1
                    },
                    {
                        key: "info",
                        name: "Sites",
                        path: `/assetmanagement/assetinfo/${sidePanelValues?.client_id}/sites?parentSection=asset`,
                        index: 2
                    }
                ];
                bulkResetBreadCrumpData(bc);
                history.push(`/assetmanagement/assetinfo/${sidePanelValues?.client_id}/sites?parentSection=asset`, {
                    from: "assetDashboard"
                });
            } else {
                history.push(`/project/projectinfo/${sidePanelValues.project_ids[0]}/sites`);
                let bc = [
                    { key: "dashboard", name: "Dashboard", path: "/dashboard", index: 0 },
                    {
                        key: "projectName",
                        name: sidePanelValues.project_name,
                        path: `/project/projectinfo/${sidePanelValues.project_ids[0]}/basicdetails`,
                        index: 1
                    },
                    {
                        key: "info",
                        name: "Sites",
                        path: `/project/projectinfo/${sidePanelValues.project_ids[0]}/sites`,
                        index: 2
                    }
                ];
                bulkResetBreadCrumpData(bc);
            }
        };
        navigateWithPrompts({
            isFormDirty: this.props.commonReducer.isFormDirty,
            navigateAction: action
        });
    };

    handleRegionView = async (type = "") => {
        const action = () => {
            const { sidePanelValues } = this.state;
            this.setState({
                activeSection: "region"
            });
            if (type === "client") {
                let bc = [
                    getDashboardBreadCrumb(this.getActiveDashboardKey()),
                    {
                        key: "assetName",
                        name: sidePanelValues?.client_name,
                        path: `/assetmanagement/assetinfo/${sidePanelValues?.client_id}/basicdetails`,
                        index: 1
                    },
                    {
                        key: "info",
                        name: "Regions",
                        path: `/assetmanagement/assetinfo/${sidePanelValues?.client_id}/regions?parentSection=asset`,
                        index: 2
                    }
                ];
                bulkResetBreadCrumpData(bc);
                history.push(`/assetmanagement/assetinfo/${sidePanelValues?.client_id}/regions?parentSection=asset`, {
                    from: "assetDashboard"
                });
            } else {
                if (sidePanelValues && sidePanelValues.project_ids && sidePanelValues.project_ids.length) {
                    history.push(`/project/projectinfo/${sidePanelValues.project_ids[0]}/regions`);
                    let bc = [
                        { key: "dashboard", name: "Dashboard", path: "/dashboard", index: 0 },
                        {
                            key: "projectName",
                            name: sidePanelValues.project_name,
                            path: `/project/projectinfo/${sidePanelValues.project_ids[0]}/basicdetails`,
                            index: 1
                        },
                        {
                            key: "info",
                            name: "Regions",
                            path: `/project/projectinfo/${sidePanelValues.project_ids[0]}/regions`,
                            index: 2
                        }
                    ];
                    bulkResetBreadCrumpData(bc);
                }
            }
        };
        navigateWithPrompts({
            isFormDirty: this.props.commonReducer.isFormDirty,
            navigateAction: action
        });
    };

    handleRecommentationView = async () => {
        const action = () => {
            const { sidePanelValues } = this.state;
            this.setState({
                activeSection: "recommendation"
            });
            if (sidePanelValues && sidePanelValues.project_ids && sidePanelValues.project_ids.length) {
                history.push(`/project/projectinfo/${sidePanelValues.project_ids[0]}/recommendations`, {
                    from: "dashboard"
                });
                let bc = [
                    { key: "dashboard", name: "Dashboard", path: "/dashboard", index: 0 },
                    {
                        key: "projectName",
                        name: sidePanelValues.project_name,
                        path: `/project/projectinfo/${sidePanelValues.project_ids[0]}/basicdetails`,
                        index: 1
                    },
                    {
                        key: "info",
                        name: "Recommendations",
                        path: `/project/projectinfo/${sidePanelValues.project_ids[0]}/recommendations`,
                        index: 2
                    }
                ];
                bulkResetBreadCrumpData(bc);
            }
        };
        navigateWithPrompts({
            isFormDirty: this.props.commonReducer.isFormDirty,
            navigateAction: action
        });
    };
    handleAssetsView = async () => {
        const action = () => {
            const { sidePanelValues } = this.state;
            const clientId = sidePanelValues?.client_id;
            const clientName = sidePanelValues?.client_name;
            this.setState({
                activeSection: "asset"
            });
            if (clientId) {
                const basePath = `/assetmanagement/assetinfo/${clientId}`;
                const isMobileSource = this.isMobileAssetDashboardView();
                const assetsTabPath = `${basePath}/${isMobileSource ? "survey-assets" : "assets"}?parentSection=asset`;
                bulkResetBreadCrumpData([
                    getDashboardBreadCrumb(this.getActiveDashboardKey()),
                    {
                        key: "assetName",
                        name: clientName,
                        path: `${basePath}/basicdetails?parentSection=asset`,
                        index: 1
                    },
                    {
                        key: "info",
                        name: isMobileSource ? "Mobile Assets" : "Assets",
                        path: assetsTabPath,
                        index: 2
                    }
                ]);
                history.push(assetsTabPath, {
                    from: getAssetDashboardFrom(this.getAssetSidePanelChartParams()),
                    ...(hasAssetDashboardNavFilters(this.props.assetManagementReducer?.chartParams) ? {} : { isInitialView: true })
                });
            }
        };
        navigateWithPrompts({
            isFormDirty: this.props.commonReducer.isFormDirty,
            navigateAction: action
        });
    };

    handleCapitalRequestView = async () => {
        const action = () => {
            const { sidePanelValues } = this.state;
            this.setState({
                activeSection: "cr-recommendations"
            });
            if (sidePanelValues && sidePanelValues.project_ids && sidePanelValues.project_ids.length) {
                history.push(`/project/projectinfo/${sidePanelValues.project_ids[0]}/cr-recommendations`);
                let bc = [
                    { key: "dashboard", name: "Dashboard", path: "/dashboard", index: 0 },
                    {
                        key: "projectName",
                        name: sidePanelValues.project_name,
                        path: `/project/projectinfo/${sidePanelValues.project_ids[0]}/basicdetails`,
                        index: 1
                    },
                    {
                        key: "info",
                        name: getCapitalRequestLabel(this.props.projectReducer?.getProjectByIdResponse?.miscellaneous),
                        path: `/project/projectinfo/${sidePanelValues.project_ids[0]}/cr-recommendations`,
                        index: 2
                    }
                ];
                bulkResetBreadCrumpData(bc);
            }
        };
        navigateWithPrompts({
            isFormDirty: this.props.commonReducer.isFormDirty,
            navigateAction: action
        });
    };

    handleBuildingType = (ids, type, e) => {
        const action = () => {
            e.stopPropagation();
            const { sidePanelValues, filterValues } = this.state;
            this.setState({
                activeSection: type,
                activeBuildingType: type
            });
            if (sidePanelValues && sidePanelValues.project_ids && sidePanelValues.project_ids.length) {
                let tempFilterParams = {};
                let filterNames = [...filterValues];
                const buildingTypeIndex = filterNames.findIndex(filter => filter.name === "Building Type");

                if (buildingTypeIndex !== -1) {
                    filterNames[buildingTypeIndex].value = [type];
                } else {
                    filterNames.push({ name: "Building Type", value: [type] });
                }
                tempFilterParams["building_types"] = [type];
                this.props.saveTempChartFilters(tempFilterParams);
                this.props.modifyFilter(filterNames, this.state.dashboardFilterParams);
                this.props.getDashboard(
                    this.getDashboardReportParams({
                        ...this.state.dashboardFilterParams,
                        ...this.props.dashboardReducer.individualFilters,
                        ...tempFilterParams,
                        ...this.props.dashboardReducer.tempQueryChartFilters
                    })
                );

                history.push(`/project/projectinfo/${sidePanelValues.project_ids[0]}/buildings`);
                let bc = [
                    { key: "dashboard", name: "Dashboard", path: "/dashboard", index: 0 },
                    { key: "info", name: "FCA Projects", path: "/project", index: 1 },
                    {
                        key: "projectName",
                        name: sidePanelValues.project_name,
                        path: `/project/projectinfo/${sidePanelValues.project_ids[0]}/basicdetails`,
                        index: 2
                    },
                    { key: "info", name: "Buildings", path: `/project/projectinfo/${sidePanelValues.project_ids[0]}/buildings`, index: 3 }
                ];
                bulkResetBreadCrumpData(bc);
            }
        };
        navigateWithPrompts({
            isFormDirty: this.props.commonReducer.isFormDirty,
            navigateAction: action
        });
    };

    clearBuildingFilter = (e, type) => {
        e.stopPropagation();
        const { filterValues } = this.state;
        this.setState({
            activeSection: "",
            activeBuildingType: ""
        });
        let filterNames = [...filterValues];
        filterNames = filterNames.filter(filter => filter.name !== "Building Type");
        this.props.saveTempChartFilters({});
        this.props.modifyFilter(filterNames, this.state.dashboardFilterParams);
        this.props.getDashboard(
            this.getDashboardReportParams({
                ...this.state.dashboardFilterParams,
                ...this.props.dashboardReducer.individualFilters,
                ...this.props.dashboardReducer.tempQueryChartFilters
            })
        );
    };

    handleClearFilterData = (data, item) => {
        let currentData = this.state.filterValues.map((fv, key) => {
            fv.value = fv.value.filter(v => v !== item);
            return fv;
        });
    };

    getParamsForSideMenu = (entity, parentId, grandParentId, gGrandParentId, gGGParentId) => {
        // eslint-disable-next-line default-case
        switch (entity) {
            case "projects":
                return {
                    entity: entity,
                    response: "getProjectMenuItemsResponse",
                    params: {}
                };
            case "project_regions":
                return {
                    entity: entity,
                    response: "getProjectRegionMenuItemsResponse",
                    params: {
                        project_id: parentId
                    }
                };
            case "project_sites":
                return {
                    entity: entity,
                    response: "getProjectSiteMenuItemsResponse",
                    params: {
                        project_id: parentId,
                        region_id: grandParentId
                    }
                };
            case "project_buildings":
                return {
                    entity: entity,
                    response: "getProjectBuildingMenuItemsResponse",
                    params: {
                        project_id: parentId,
                        region_id: grandParentId,
                        site_id: gGrandParentId
                    }
                };
            case "project_floors":
                return {
                    entity: entity,
                    response: "getProjectFloorMenuItemsResponse",
                    params: {
                        project_id: parentId,
                        region_id: grandParentId,
                        site_id: gGrandParentId,
                        building_id: gGGParentId
                    }
                };
            case "reports":
                return {
                    entity: entity,
                    response: "getReportMenuItemsResponse",
                    params: {}
                };
            case "report_regions":
                return {
                    entity: entity,
                    response: "getReportRegionMenuItemsResponse",
                    params: {
                        project_id: parentId
                    }
                };
            case "report_sites":
                return {
                    entity: entity,
                    response: "getReportSiteMenuItemsResponse",
                    params: {
                        project_id: parentId,
                        region_id: grandParentId
                    }
                };
            case "report_buildings":
                return {
                    entity: entity,
                    response: "getReportBuildingMenuItemsResponse",
                    params: {
                        project_id: parentId,
                        region_id: grandParentId,
                        site_id: gGrandParentId
                    }
                };
            case "efcis":
                return {
                    entity: entity,
                    response: "getEfciMenuItemsResponse",
                    // response: "getProjectMenuItemsResponse",
                    params: {}
                };
            case "efci_regions":
                return {
                    entity: entity,
                    response: "getEfciRegionMenuItemsResponse",
                    // response: "getProjectRegionMenuItemsResponse",
                    params: {
                        project_id: parentId
                    }
                };
            case "efci_sites":
                return {
                    entity: entity,
                    response: "getEfciSiteMenuItemsResponse",
                    params: {
                        project_id: parentId,
                        region_id: grandParentId
                    }
                };
            case "efci_buildings":
                return {
                    entity: entity,
                    response: "getEfciBuildingMenuItemsResponse",
                    params: {
                        project_id: parentId,
                        region_id: grandParentId,
                        site_id: gGrandParentId
                    }
                };
            case "regions":
                return {
                    entity: entity,
                    response: "getRegionMenuItemsResponse",
                    params: {}
                };
            case "region_sites":
                return {
                    entity: entity,
                    response: "getRegionSiteMenuItemsResponse",
                    params: {
                        region_id: parentId
                    }
                };
            case "region_buildings":
                return {
                    entity: entity,
                    response: "getRegionBuildingMenuItemsResponse",
                    params: {
                        region_id: parentId,
                        site_id: grandParentId
                    }
                };
            case "region_floors":
                return {
                    entity: entity,
                    response: "getRegionFloorMenuItemsResponse",
                    params: {
                        region_id: parentId,
                        site_id: grandParentId,
                        building_id: gGrandParentId
                    }
                };
            case "sites":
                return {
                    entity: entity,
                    response: "getSiteMenuItemsResponse",
                    params: {}
                };
            case "site_buildings":
                return {
                    entity: entity,
                    response: "getSiteBuildingMenuItemsResponse",
                    params: {
                        site_id: parentId
                    }
                };
            case "site_floors":
                return {
                    entity: entity,
                    response: "getSiteFloorMenuItemsResponse",
                    params: {
                        site_id: parentId,
                        building_id: grandParentId
                    }
                };
            case "buildings":
                return {
                    entity: entity,
                    response: "getBuildingMenuItemsResponse",
                    params: {}
                };
            case "building_floors":
                return {
                    entity: entity,
                    response: "getBuildingFloorMenuItemsResponse",
                    params: {
                        building_id: parentId
                    }
                };
            case "clients":
                return {
                    entity: entity,
                    response: "getClientMenuItemsResponse",
                    params: {}
                };
            case "consultancies":
                return {
                    entity: entity,
                    response: "getConsultancyMenuItemsResponse",
                    params: {}
                };
        }
    };

    sideMenuHandler = async (entity, item, parentId, grandParentId, gGrandParentId, gGGParenteId) => {
        if (entity) {
            let params = this.getParamsForSideMenu(entity, parentId, grandParentId, gGrandParentId, gGGParenteId);
            await this.props.getSideMenuItems(params);
            const data = this.props.commonReducer[params?.response] && this.props.commonReducer[params?.response][params?.entity];
            this.appendMenuData(data, item, true);
        }
    };

    replaceMatchingMenuNodes = (existingNodes = [], searchNodes = []) => {
        if (!existingNodes?.length || !searchNodes?.length) return existingNodes;

        const searchNodeByKey = new Map(searchNodes.filter(node => node?.key).map(node => [node.key, node]));

        return existingNodes.map(node => {
            const searchNode = searchNodeByKey.get(node?.key);
            return searchNode ? { ...node, ...searchNode } : node;
        });
    };

    mergeFetchedMenuNodes = (existingNodes = [], fetchedNodes = []) => {
        if ((existingNodes || [])?.length > (fetchedNodes || [])?.length) {
            return [...fetchedNodes];
        }

        return _.uniqBy([...(existingNodes || []), ...(fetchedNodes || [])], "key");
    };

    getSearchSelectionPath = ({ item, node, nodeItem, child, building, floor } = {}) => {
        return [item, node, nodeItem, child, building, floor]?.filter(Boolean);
    };

    getChildEntityName = entity => {
        switch (entity) {
            case "projects":
                return "project_regions";
            case "efcis":
                return "efci_regions";
        }
    };

    getGrandChildEntityName = entity => {
        switch (entity) {
            case "projects":
                return "project_sites";
            case "efcis":
                return "efci_sites";
        }
    };

    getGGrandChildEntityName = entity => {
        switch (entity) {
            case "projects":
                return "project_buildings";
            case "efcis":
                return "efci_buildings";
        }
    };

    getFloorEntityName = entity => {
        switch (entity) {
            case "projects":
                return "project_floors";
        }
    };

    fetchMenuData = async (entity, parentId, grandParentId, gGrandParentId, gGGParenteId) => {
        if (!entity) return [];

        const params = this.getParamsForSideMenu(entity, parentId, grandParentId, gGrandParentId, gGGParenteId);
        if (!params) return [];

        await this.props.getSideMenuItems(params);
        const responseData = this.props.commonReducer?.[params?.response];
        const data = responseData && responseData[params?.entity];

        return Array.isArray(data) ? data : [];
    };

    fetchSearchSelectionParentData = async ({ item, node, nodeItem, child, building, floor } = {}) => {
        const rootEntity = item?.name;
        if (!rootEntity || !["projects", "efcis"].includes(rootEntity)) return;

        const menuRequests = [];
        const addMenuRequest = (entity, menuItem, ...ids) => {
            if (entity && menuItem) {
                menuRequests.push({ item: menuItem, promise: this.fetchMenuData(entity, ...ids) });
            }
        };

        addMenuRequest(rootEntity, item);

        if (nodeItem || child || building || floor) {
            addMenuRequest(this.getChildEntityName(rootEntity), node, node?.key);
        }

        if (child || building || floor) {
            addMenuRequest(this.getGrandChildEntityName(rootEntity), nodeItem, node?.key, nodeItem?.key);
        }

        if (building || floor) {
            addMenuRequest(this.getGGrandChildEntityName(rootEntity), child, node?.key, nodeItem?.key, child?.key);
        }

        if (floor) {
            addMenuRequest(this.getFloorEntityName(rootEntity), building, node?.key, nodeItem?.key, child?.key, building?.key);
        }

        for (const menuRequest of menuRequests) {
            const fetchedMenuData = await menuRequest.promise;
            await this.appendMenuData(fetchedMenuData, menuRequest?.item, true, true);
        }
    };

    handleSidebarSearchResultSelection = async selection => {
        const path = this.getSearchSelectionPath(selection);
        const selectedMenu = path?.[0];
        if (!selectedMenu?.key || !["projects", "efci"].includes(selectedMenu.key)) return;

        this.menuSearchBaseMenuData = null;
        await this.fetchSearchSelectionParentData(selection);
        await new Promise(resolve => this.setState({ forceExpandPath: path }, resolve));
    };

    updateMenuTreeWithFetchedNodes = (nodes = [], item, fetchedNodes = [], open, level = 0) => {
        if (!nodes?.length) return nodes;

        let changed = false;
        const updatedNodes = nodes.map(node => {
            if (!node) return node;

            if (node.key === item.key) {
                changed = true;
                if (!open) return { ...node, nodes: [] };

                const nextNodes = level <= 1 ? this.mergeFetchedMenuNodes(node.nodes || [], fetchedNodes || []) : fetchedNodes || [];
                return { ...node, nodes: nextNodes };
            }

            if (node.nodes?.length && (open || item.entity !== node.entity)) {
                const updatedChildren = this.updateMenuTreeWithFetchedNodes(node.nodes, item, fetchedNodes, open, level + 1);
                if (updatedChildren !== node.nodes) {
                    changed = true;
                    return { ...node, nodes: updatedChildren };
                }
            }

            return node;
        });

        return changed ? updatedNodes : nodes;
    };

    appendMenuData = (temp, item, open, issearchDefaultExpand = false) => {
        const fetchedNodes = temp || [];
        return new Promise(resolve => {
            this.setState(
                prevState => {
                    const menuData = this.updateMenuTreeWithFetchedNodes(prevState.menuData, item, fetchedNodes, open);
                    const shouldUpdateSearchTree = Boolean(
                        prevState.sidebarSearchQuery &&
                        prevState.menuSearchTree?.length &&
                        ((item?.key !== "projects" && item?.key !== "efci") ||
                            (item?.key === "projects" && !item?.nodes?.length) ||
                            (item?.key === "efci" && !item?.nodes?.length))
                    );
                    const menuSearchTree = shouldUpdateSearchTree
                        ? this.updateMenuTreeWithFetchedNodes(prevState.menuSearchTree, item, fetchedNodes, open)
                        : prevState.menuSearchTree;

                    return {
                        menuData,
                        ...(issearchDefaultExpand ? {} : { menuSearchTree })
                    };
                },
                () => {
                    if (this.state.activeMenuSearchQuery) {
                        this.menuSearchCache[this.state.activeMenuSearchQuery] = this.state.menuSearchTree;
                    }
                    resolve();
                }
            );
        });
    };

    handleLogoClick = () => {
        const action = () => {
            resetBreadCrumpData(getDashboardBreadCrumb(this.getActiveDashboardKey()));
            this.props.history.push(getDefaultDashboardLocation());
            this.collapseAllItem();
        };
        navigateWithPrompts({
            isFormDirty: this.props.commonReducer.isFormDirty,
            navigateAction: action
        });
    };

    handleLandingClick = () => {
        const action = () => {
            resetBreadCrumpData({
                key: "main",
                name: "Home",
                path: "/home"
            });
            this.props.history.push("/home");
            this.collapseAllItem();
        };
        navigateWithPrompts({
            isFormDirty: this.props.commonReducer.isFormDirty,
            navigateAction: action
        });
    };

    renderGotoLandingPageConfirmationModal = () => {
        const { showGotoLandingConfirmModal } = this.state;
        if (!showGotoLandingConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={"Close and return to Landing Page ?"}
                        message={""}
                        onNo={() => this.setState({ showGotoLandingConfirmModal: false })}
                        onYes={() => {
                            this.setState({ showGotoLandingConfirmModal: false });
                            this.handleLandingClick();
                        }}
                    />
                }
                onCancel={() => this.setState({ showGotoLandingConfirmModal: false })}
            />
        );
    };

    toggleFavoriteSmartChartReportsModal = () => {
        this.setState({ showFavoriteSmartChartReportsModal: !this.state.showFavoriteSmartChartReportsModal });
    };

    canSeeDashboardMenu = () => checkPermission("menu", DASHBOARD_MENU_PERMISSION, null);

    getPickerDashboardOptions = () =>
        this.canSeeDashboardMenu()
            ? DASHBOARD_OPTIONS.filter(option => checkPermission("charts_and_graph", option.chartPermission, "view"))
            : [];

    getActiveDashboardKey = () => {
        const isAssetDashboard = this.isAssetDashboardRoute() || (!this.isFcaDashboardRoute() && isAssetDefaultDashboard());
        if (!isAssetDashboard) return FCA_DASHBOARD;
        return resolveAssetDashboardFrom(this.props.assetManagementReducer?.chartParams);
    };

    handleDashboardSelect = option => {
        if (this.isDashboardStatsRoute() && option.key === this.getActiveDashboardKey()) return;
        const action = () => {
            setDefaultDashboardView(DEFAULT_DASHBOARD_VIEW_BY_KEY[option.key] || "fca_dashboard");
            if (option.source) {
                this.props.saveMasterFilters({
                    ...(this.props.assetManagementReducer?.chartParams || {}),
                    from: option.source
                });
            }
            bulkResetBreadCrumpData([getDashboardBreadCrumb(option.key)]);
            this.props.history.push(getDashboardPath(option));
        };
        navigateWithPrompts({
            isFormDirty: this.props.commonReducer.isFormDirty,
            navigateAction: action
        });
    };

    toggleFavoriteMenu = item => {
        this.setState({ quickLinksConfirmationModal: { show: true, item } });
    };

    renderQuickLinksConfirmationModal = () => {
        if (!this.state.quickLinksConfirmationModal?.show) return null;
        const { item } = this.state.quickLinksConfirmationModal;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={
                            !item?.linkId
                                ? "Are you sure you want to add this Menu to Bookmarks?"
                                : "Are you sure you want to remove this Menu from Bookmarks?"
                        }
                        message={"Bookmarks menu is accessible in Dashboard"}
                        type="cancel"
                        onNo={() => this.setState({ quickLinksConfirmationModal: { show: false, item: null } })}
                        onYes={this.handleAddToQuickLinks}
                    />
                }
                onCancel={() => this.setState({ quickLinksConfirmationModal: { show: false, item: null } })}
            />
        );
    };

    findPath = (targetKey, data = this.state.menuData, path = []) => {
        if (!data) return null;
        for (let item of data) {
            if (item?.key === targetKey) return [...path, item];
            if (item?.nodes && item?.nodes?.length) {
                const res = this.findPath(targetKey, item?.nodes, [...path, item]);
                if (res) return res;
            }
        }
        return null;
    };

    matchesMenuSearch = (entry, query) => {
        const searchText = [
            entry?.node?.label,
            entry?.node?.name,
            entry?.node?.entity,
            entry?.chain?.map(item => item?.label || item?.name || item?.entity).join(" ")
        ]
            .filter(Boolean)
            .join(" ")
            .toLowerCase();

        return searchText.includes(query);
    };
    filterScrollMenuNodes = (nodes, queryLower) => {
        if (!nodes?.length) return [];
        if (!queryLower) return nodes;

        const out = [];

        for (const node of nodes) {
            if (node?.view === false) continue;

            const labelText = [node?.label || node?.name, node?.entity].filter(Boolean).join(" ").toLowerCase();
            const selfMatch = labelText.includes(queryLower);
            const firstLevelChildren = (node?.nodes || []).filter(child => child?.view !== false);
            const childFiltered = firstLevelChildren.filter(child => {
                const childText = [node?.label || node?.name, child?.label || child?.name, child?.entity]?.filter(Boolean)?.join(" ")?.toLowerCase();
                return childText?.includes(queryLower);
            });

            if (!selfMatch && childFiltered?.length === 0) continue;

            out.push({
                ...node,
                nodes: selfMatch ? firstLevelChildren : childFiltered
            });
        }

        return out;
    };

    menuMatchesSearch = (menu, queryLower) => {
        const searchText = [menu?.label].filter(Boolean).join(" ").toLowerCase();

        return searchText.includes(queryLower);
    };

    buildLocalSearchMenuTree = queryLower => {
        if (!queryLower) return [];

        return (this.state.menuData || [])
            .filter(menu => ["projects", "efci"].includes(menu?.key) && menu?.view === true && this.menuMatchesSearch(menu, queryLower))
            .map(menu => ({ ...menu, nodes: [] }));
    };

    buildSearchMenuTree = response => {
        const results = response?.results || {};
        const projectNodes = results?.project || [];
        const efciNodes = results?.efci || [];
        const queryLower = response?.query?.toLowerCase() || this.state.sidebarSearchQuery?.toLowerCase();
        const projectMenu = this.state.menuData?.find(menu => menu.key === "projects");
        const efciMenu = this.state.menuData?.find(menu => menu.key === "efci");
        const searchTree = [];

        if (projectMenu && (projectNodes?.length || this.menuMatchesSearch(projectMenu, queryLower))) {
            searchTree.push({ ...projectMenu, nodes: projectNodes });
        }
        if (efciMenu && (efciNodes?.length || this.menuMatchesSearch(efciMenu, queryLower))) {
            searchTree.push({ ...efciMenu, nodes: efciNodes });
        }

        return searchTree;
    };

    handleMenuSearchResponse = response => {
        const query = response?.query?.toLowerCase();
        const currentQuery = this.state.sidebarSearchQuery?.toLowerCase();
        if (!query || query !== currentQuery) return;

        const menuSearchTree = response?.success ? this.buildSearchMenuTree(response) : this.buildLocalSearchMenuTree(query);
        const results = response?.results || {};
        const hasProjectResults = Array.isArray(results?.project);
        const hasEfciResults = Array.isArray(results?.efci);
        if (response?.success !== false && (hasProjectResults || hasEfciResults) && !this.menuSearchBaseMenuData) {
            this.menuSearchBaseMenuData = this.state.menuData;
        }
        const menuData =
            response?.success === false
                ? this.state.menuData
                : (this.state.menuData || []).map(menu => {
                      if (menu.key === "projects" && hasProjectResults) {
                          return { ...menu, nodes: this.replaceMatchingMenuNodes(menu.nodes, results.project) };
                      }
                      if (menu.key === "efci" && hasEfciResults) {
                          return { ...menu, nodes: this.replaceMatchingMenuNodes(menu.nodes, results.efci) };
                      }
                      return menu;
                  });
        this.menuSearchCache[query] = menuSearchTree;
        this.setState({
            menuData,
            menuSearchTree,
            activeMenuSearchQuery: query,
            isSidebarSearchRequestPending: false
        });
    };

    requestMenuSearch = query => {
        const normalizedQuery = query?.toLowerCase();

        clearTimeout(this.sidebarSearchDebounceTimer);
        if (!normalizedQuery) {
            const menuData = this.menuSearchBaseMenuData || this.state.menuData;
            this.menuSearchBaseMenuData = null;

            this.setState({
                menuData,
                menuSearchTree: [],
                activeMenuSearchQuery: "",
                isSidebarSearchTypingLoading: false,
                isSidebarSearchRequestPending: false
            });
            return;
        }
        // if (this.menuSearchCache[normalizedQuery]) {
        //     const menuSearchTree = this.menuSearchCache[normalizedQuery];
        //     this.setState({
        //         menuSearchTree,
        //         activeMenuSearchQuery: normalizedQuery
        //     });
        //     return;
        // }

        this.setState({
            menuSearchTree: this.buildLocalSearchMenuTree(normalizedQuery),
            activeMenuSearchQuery: normalizedQuery
        });

        this.sidebarSearchDebounceTimer = setTimeout(() => {
            this.props.searchMenuItems?.({ search: normalizedQuery });
        }, 300);
    };

    getFlyoutEntriesForSearch = () => {
        const { hoveredItem } = this.state;
        return (hoveredItem?.nodes || [])
            .filter(node => node?.view !== false && node?.url)
            .map(node => ({ node, chain: hoveredItem ? [hoveredItem, node] : [node] }));
    };

    filterFlyoutEntries = (entries, query) => {
        const { hoveredItem } = this.state;
        const trimmedQuery = query?.toLowerCase();
        if (!trimmedQuery) {
            return (hoveredItem?.nodes || [])
                .filter(node => node?.view !== false)
                .map(node => ({ node, chain: hoveredItem ? [hoveredItem, node] : [node] }));
        }

        return entries.filter(entry => this.matchesMenuSearch(entry, trimmedQuery));
    };

    handleSidebarSearchChange = e => {
        const sidebarSearchQuery = e.target.value;
        const hasSearchQuery = Boolean(sidebarSearchQuery);
        this.setState(
            {
                sidebarSearchQuery,
                isSidebarSearchTypingLoading: hasSearchQuery,
                isSidebarSearchRequestPending: hasSearchQuery
            },
            () => this.requestMenuSearch(sidebarSearchQuery)
        );
    };

    handleSidebarSearchExpandComplete = completedQuery => {
        const currentQuery = this.state.sidebarSearchQuery?.toLowerCase();
        if (completedQuery && completedQuery !== currentQuery) return;
        if (this.state.isSidebarSearchRequestPending || this.props.commonReducer?.menuSearchLoading) return;

        this.setState({ isSidebarSearchTypingLoading: false });
    };

    clearSidebarSearch = ({ collapse = false } = {}) => {
        if (collapse) {
            this.sideNavSearchInputRef?.current?.blur();
        }

        clearTimeout(this.sidebarSearchDebounceTimer);
        this.setState(prevState => ({
            sidebarSearchQuery: "",
            isSidebarSearchTypingLoading: false,
            isSidebarSearchRequestPending: false
        }));
    };

    toggleFlyoutSearch = () => {
        this.setState(
            prevState => ({
                isFlyoutSearchExpanded: !prevState.isFlyoutSearchExpanded,
                flyoutSearchQuery: prevState.isFlyoutSearchExpanded ? "" : prevState.flyoutSearchQuery
            }),
            () => {
                if (this.state.isFlyoutSearchExpanded) {
                    this.flyoutSearchInputRef?.current?.focus();
                } else {
                    this.flyoutSearchInputRef?.current?.blur();
                }
            }
        );
    };

    clearFlyoutSearch = ({ collapse = false } = {}) => {
        this.setState(
            prevState => ({
                flyoutSearchQuery: "",
                isFlyoutSearchExpanded: collapse ? false : prevState.isFlyoutSearchExpanded
            }),
            () => {
                if (!this.state.isFlyoutSearchExpanded) {
                    this.flyoutSearchInputRef?.current?.blur();
                } else {
                    this.flyoutSearchInputRef?.current?.focus();
                }
            }
        );
    };

    handleAddToQuickLinks = async () => {
        this.setState({ quickLinksConfirmationModal: { show: false, item: null } });
        const user_id = localStorage.getItem("userId");
        const { item } = this.state.quickLinksConfirmationModal;
        if (item.linkId) {
            await this.props.deleteQuickLinks(item.linkId, user_id);
        } else {
            const breadCrumbs = item.key === "energyManagement" || item.key === "assetmanagement" ? [item.bc[0]] : item.bc;
            const params = {
                user_id,
                name: item.label,
                url: `/${item.baseUrl || item.url}`,
                bread_crumbs: JSON.stringify(breadCrumbs),
                key: item.permissionKeys ? JSON.stringify(item.permissionKeys) : null
            };
            await this.props.addToQuickLinks(params);
        }
    };

    toggleFullscreen = event => {
        var element = document.getElementsByTagName("BODY")[0];
        var isFullscreen = document.webkitIsFullScreen || document.mozFullScreen || false;
        if (event instanceof HTMLElement) {
            element = event;
        }

        element.requestFullScreen =
            element.requestFullScreen ||
            element.webkitRequestFullScreen ||
            element.mozRequestFullScreen ||
            function () {
                return false;
            };
        document.cancelFullScreen =
            document.cancelFullScreen ||
            document.webkitCancelFullScreen ||
            document.mozCancelFullScreen ||
            function () {
                return false;
            };

        if (isFullscreen) {
            document.cancelFullScreen();
        } else {
            element.requestFullScreen();
        }
        isFullscreen ? document.cancelFullScreen() : element.requestFullScreen();
        this.setState({
            isFullView: isFullscreen
        });
    };
    handleRailHover = (e, item) => {
        clearTimeout(this.hideTimer);
        if (!item?.nodes || item?.nodes?.length === 0) {
            this.setState({ showFlyout: false, hoveredItem: null, flyoutSearchQuery: "", isFlyoutSearchExpanded: false });
            return;
        }

        const sideMenuElement = document.getElementById("sidebar");
        const sideMenuRect = sideMenuElement ? sideMenuElement.getBoundingClientRect() : { right: this.props?.showNav ? 272 : 72 };

        const rect = e.currentTarget.getBoundingClientRect();

        let totalVisibleItems = 0;
        if (item?.nodes) {
            item?.nodes?.forEach(node => {
                if (node?.view !== false) {
                    totalVisibleItems += 1;
                    if (node?.nodes) {
                        totalVisibleItems += node?.nodes?.filter(c => c?.view !== false)?.length;
                    }
                }
            });
        }
        const path = this.findPath(item.key);
        this.setState(
            {
                showFlyout: true,
                hoveredItem: item,
                hoveredPath: path,
                flyoutTop: rect?.top,
                flyoutLeft: sideMenuRect.right + 2,
                flyoutMaxHeight: 500,
                flyoutSearchQuery: "",
                isFlyoutSearchExpanded: false
            },
            () => {
                requestAnimationFrame(() => {
                    const flyout = document.querySelector(".menu-flyout");

                    if (!flyout) return;

                    const realHeight = flyout?.offsetHeight;

                    let flyoutTop = rect.top;

                    if (flyoutTop + realHeight > window?.innerHeight - 10) {
                        flyoutTop = window?.innerHeight - realHeight - 10;
                    }

                    flyoutTop = Math.max(10, flyoutTop);

                    const arrowTop = rect.top + rect.height / 2 - flyoutTop;

                    this.setState({
                        flyoutTop,
                        arrowTop
                    });
                });
            }
        );
    };

    handleRailLeave = () => {
        clearTimeout(this.hideTimer);
        this.hideTimer = setTimeout(() => {
            if (!this.isHoveringFlyout) {
                this.setState({ showFlyout: false, hoveredItem: null, flyoutSearchQuery: "" });
            }
        }, 100);
    };

    cancelHide = () => {
        clearTimeout(this.hideTimer);
        this.isHoveringFlyout = true;
    };

    flyoutLeave = () => {
        this.isHoveringFlyout = false;
        clearTimeout(this.hideTimer);
        this.hideTimer = setTimeout(() => {
            if (!this.state.hoveredItem) return;
            this.setState({ showFlyout: false, hoveredItem: null, flyoutSearchQuery: "" });
        }, 100);
    };
    flyoutTypeKeyListener = e => {
        if (document.activeElement === this.flyoutSearchInputRef?.current) return;

        if (e?.ctrlKey || e?.metaKey || e?.altKey) return;

        if (e?.key === "Escape") {
            if (this.state.flyoutSearchQuery) {
                this.setState({ flyoutSearchQuery: "" });
            } else if (this.state.isFlyoutSearchExpanded) {
                this.setState({ isFlyoutSearchExpanded: false });
            } else {
                this.setState({ showFlyout: false, hoveredItem: null });
            }
            return;
        }

        if (e?.key === "Backspace") {
            this.setState(prev => ({
                flyoutSearchQuery: (prev?.flyoutSearchQuery || "").slice(0, -1),
                isFlyoutSearchExpanded: true
            }));
            return;
        }

        if (e.key.length === 1) {
            e.preventDefault();
            this.setState(
                prev => ({
                    flyoutSearchQuery: prev?.flyoutSearchQuery + e?.key,
                    isFlyoutSearchExpanded: true
                }),
                () => {
                    if (this.flyoutSearchInputRef?.current) {
                        this.flyoutSearchInputRef.current.focus();
                        const len = this.flyoutSearchInputRef.current.value.length;
                        this.flyoutSearchInputRef.current.setSelectionRange(len, len);
                    }
                }
            );
            return;
        }
    };
    render() {
        const {
            menuData,
            showFavoriteSmartChartReportsModal,
            isFullView,
            showFlyout,
            hoveredItem,
            flyoutSearchQuery,
            isFlyoutSearchExpanded,
            sidebarSearchQuery
        } = this.state;

        const { showNav } = this.props;
        const isSidebarSearchLoading = Boolean(
            sidebarSearchQuery &&
            (this.props.commonReducer?.menuSearchLoading || this.state.isSidebarSearchTypingLoading || this.state.isSidebarSearchRequestPending)
        );

        const flyoutFilteredEntries = showFlyout && hoveredItem ? this.filterFlyoutEntries(this.getFlyoutEntriesForSearch(), flyoutSearchQuery) : [];

        const sidebarPinnedKeys = new Set(["landing-page", "dashboard", "assetDashboard"]);
        const visibleMenuItems = (menuData || []).filter(d => d.view === true);
        const pinnedMenuItems = visibleMenuItems.filter(d => sidebarPinnedKeys.has(d.key));
        const scrollMenuItems = visibleMenuItems.filter(d => !sidebarPinnedKeys.has(d.key));
        const sidebarQueryLower = sidebarSearchQuery?.toLowerCase();
        const localFilteredMenuItems = this.filterScrollMenuNodes(
            scrollMenuItems.filter(item => item.key !== "projects" && item.key !== "efci"),
            sidebarQueryLower
        );
        const sideNavMenuData =
            sidebarQueryLower?.length > 0 ? [...pinnedMenuItems, ...this.state.menuSearchTree, ...localFilteredMenuItems] : menuData;
        const assetSidePanelParams = this.isAssetDashboardRoute() ? this.getAssetSidePanelChartParams() : null;
        const sidePanelFilterValues = assetSidePanelParams
            ? getCombinedAssetDashboardFilterTags(
                  assetSidePanelParams,
                  assetSidePanelParams,
                  this.props.assetReducer?.assetDynamicFields?.asset_custom_field
              )
            : this.state.filterValues;

        let hasLandingPage = localStorage.getItem("hasLandingPage") === "true" ? true : false;

        const dashboardOptions = this.getPickerDashboardOptions();
        const showDashboardBox = dashboardOptions.length > 0;
        const projectName = this.props.dashboardReducer?.getDashboard?.side_panel?.project_name;
        const activeDashboardKey = this.getActiveDashboardKey();
        const isDashboardSection = isWithinDashboardSection(this.props.location?.pathname, findInfoPathFromBreadCrump()?.[0]);

        return (
            <>
                {" "}
                <ReactTooltip id="go-menu" />
                <ReactTooltip
                    id={SIDEBAR_CARD_TOOLTIP_ID}
                    place="right"
                    effect="solid"
                    delayShow={500}
                    backgroundColor="#007bff"
                    multiline={true}
                />
                <div
                    className={`side-nav ${APP_MODE === "training" ? "side-nav-blue" : ""} ${getDashboardTheme(
                        activeDashboardKey
                    )} ${showDashboardBox ? "has-dashboard-box" : ""} `}
                    id="sidebar"
                >
                    {showFavoriteSmartChartReportsModal && (
                        <Portal
                            body={<SmartChartReportsFavoriteListModal onCancel={this.toggleFavoriteSmartChartReportsModal} isFavoriteView={true} />}
                            onCancel={this.toggleFavoriteSmartChartReportsModal}
                        />
                    )}
                    <div className="navbar-brand" id="navBrand">
                        <div className="logo-large  dash-log">
                            <a className={"cursor-pointer"} onClick={() => this.handleLogoClick()}>
                                {" "}
                                <img id="imgLogo" src={APP_MODE === "training" ? trainingAppLogo : "/img/fca-logo.svg"} alt="" />
                            </a>

                            {/* {(this.props.match.path == '/dashboard') ?
                                (<div
                                    // className="navmenuIcon-dash"
                                    onClick={() => {
                                        this.setState({
                                            isDashboardClick: !this.state.isDashboardClick
                                        })
                                    }}>
                                    <button type="button" className="btn btn-primary btnRgion" >{this.state.isDashboardClick ? "Menu" : "Stats"}</button>
                                </div>) : null} */}
                            {/* {this.state.redirection ? ( */}
                            <div
                            // className="navmenuIcon-dash"
                            >
                                {" "}
                                <button
                                    className="btn btn--slider"
                                    data-delay-show="500"
                                    data-tip={this.state.isDashboardClick ? `Click to view options menu` : `Click to view Stats Panel`}
                                    data-effect="solid"
                                    data-for="go-menu"
                                    data-place="bottom"
                                    data-background-color="#007bff"
                                    data-active="1"
                                    onClick={() => {
                                        this.setState({
                                            isDashboardClick: !this.state.isDashboardClick
                                        });
                                    }}
                                >
                                    <span className={`btn--slider__choice ${this.state.isDashboardClick ? "active" : ""} `}>
                                        <span className="icn">
                                            <img src="/img/menu-New.svg" alt="" />
                                        </span>{" "}
                                        <span className="txt">
                                            {" "}
                                            Show <br /> Statistics
                                        </span>
                                    </span>

                                    <span className={`btn--slider__choice ${this.state.isDashboardClick ? "" : "active"}`}>
                                        {" "}
                                        <span className="icn">
                                            <img src="/img/stack.svg" alt="" />
                                        </span>
                                        <span className="txt">
                                            {" "}
                                            Show <br /> Menu
                                        </span>
                                    </span>
                                    <span
                                        className="btn--slider__toggler "
                                        style={{
                                            left: this.state.isDashboardClick ? "4px" : "57px"
                                            // width: this.state.isDashboardClick ? "20px" : "24px"
                                        }}
                                    ></span>
                                </button>
                            </div>
                            {/* ) : null} */}
                        </div>
                        {!showNav ? (
                            <div className="navmenuIcon-sm nv-mb" id="Layer_1" onClick={() => this.showNav()}>
                                <svg
                                    version="1.1"
                                    id="svg"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsxlink="http://www.w3.org/1999/xlink"
                                    x="0px"
                                    y="0px"
                                    width="120px"
                                    height="120px"
                                    viewBox="0 0 120 120"
                                    enable-background="new 0 0 120 120"
                                    xmlspace="preserve"
                                >
                                    <circle id="expandNavIcon" fill="#B7C6D5" cx="60" cy="60" r="60" />
                                    <g>
                                        <g>
                                            <path
                                                d="M45,31.709c-0.944,0.944-0.944,2.471,0,3.417L69.875,60L45,84.874c-0.944,0.945-0.944,2.472,0,3.417
                        c0.946,0.945,2.473,0.945,3.418,0L75,61.709c0.472-0.472,0.708-1.09,0.708-1.709c0-0.619-0.236-1.238-0.708-1.708L48.418,31.709
                        C47.473,30.764,45.946,30.764,45,31.709z"
                                            />
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        ) : null}
                    </div>
                    <DefaultProjectPicker activeProjectId={this.props.dashboardReducer?.defaultProject} projectName={projectName}>
                        <div className="cont-rt">
                            <div className="project-label">Project</div>
                            <div className="project-value">
                                {projectName ? (
                                    <span>{projectName}</span>
                                ) : (
                                    <span className="project-value-loading">Loading...</span>
                                )}
                            </div>
                        </div>
                    </DefaultProjectPicker>
                    {showDashboardBox && (
                        <DashboardSwitcher
                            options={dashboardOptions}
                            activeKey={activeDashboardKey}
                            isActiveRoute={isDashboardSection}
                            onSelect={this.handleDashboardSelect}
                        />
                    )}
                    {!this.state.isDashboardClick ? (
                        <div className="navList navList-main">
                            <SideNav
                                onClickItem={this.handleSideNavClick}
                                data={sideNavMenuData}
                                collapseAll={this.state.collapseAll}
                                sideMenuHandler={this.sideMenuHandler}
                                toggleFavoriteMenu={this.toggleFavoriteMenu}
                                quickLinks={this.props.dashboardReducer.getQuickLinksResponse}
                                onItemHover={(e, item) => this.handleRailHover(e, item)}
                                onItemLeave={this.handleRailLeave}
                                forceExpandPath={this.state.forceExpandPath}
                                quickLinkFocus={this.state.quickLinkFocus}
                                activeFlyoutPath={this.state.activeFlyoutPath}
                                getSideMenuItems={this.props.getSideMenuItems}
                                sidebarSearchQuery={sidebarSearchQuery}
                                sidebarSearchLoading={isSidebarSearchLoading}
                                sidebarSearchResponse={this.props.commonReducer?.menuSearchResponse}
                                sidebarSearchInputRef={this.sideNavSearchInputRef}
                                onSidebarSearchChange={this.handleSidebarSearchChange}
                                onSidebarSearchClear={this.clearSidebarSearch}
                                onSidebarSearchResultSelect={this.handleSidebarSearchResultSelection}
                                onSidebarSearchExpandComplete={this.handleSidebarSearchExpandComplete}
                            />
                            {/* <SideMenuTree
                            onClickItem={(props, level) => {
                                this.handleClick({
                                    url: props.url,
                                    bc: props.bc,
                                    label: props.label,
                                    level: level
                                });
                            }}
                            data={menuData}
                            collapseAll={this.state.collapseAll}
                        /> */}
                        </div>
                    ) : (
                        <SidePanel
                            sidePanelValues={this.state.sidePanelValues}
                            filterValues={sidePanelFilterValues}
                            handleBuildingType={this.handleBuildingType}
                            handleBuildingView={this.handleBuildingView}
                            activeSection={this.state.activeSection}
                            activeBuildingType={this.state.activeBuildingType}
                            handleView={this.handleView}
                            handleRegionView={this.handleRegionView}
                            handleSiteView={this.handleSiteView}
                            handleAdditionsView={this.handleAdditionsView}
                            handleRecommentationView={this.handleRecommentationView}
                            handleCapitalRequestView={this.handleCapitalRequestView}
                            clearBuildingFilter={this.clearBuildingFilter}
                            handleClearFilterData={this.handleClearFilterData}
                            handleFloorsView={this.handleFloorsView}
                            isAssetDashboardView={this.isAssetStatsView()}
                            isMobileAssetDashboardView={this.isMobileAssetDashboardView()}
                            handleAssetsView={this.handleAssetsView}
                            handleClientView={this.handleClientView}
                        />
                    )}
                    <Footer />
                </div>
                {this.state?.showFlyout && this.state?.hoveredItem && !this.state.isDashboardClick && !this.state?.sidebarSearchQuery && (
                    <div
                        onMouseEnter={this.cancelHide}
                        onMouseLeave={this.flyoutLeave}
                        className="menu-flyout"
                        role="dialog"
                        aria-label={`${this.state.hoveredItem.label} submenu. Type to search.`}
                        style={{
                            top: `${this.state?.flyoutTop}px`,
                            left: `${this.state.flyoutLeft}px`,
                            maxHeight: `${this.state.flyoutMaxHeight}px`
                        }}
                    >
                        {this.state?.flyoutSearchQuery ? null : (
                            <div
                                className="flyout-arrow"
                                style={{
                                    top: `${this.state.arrowTop - 10}px`
                                }}
                            />
                        )}
                        <div className="flyout-content">
                            <div className="flyout-header d-flex align-items-center justify-content-between">
                                <span className="flyout-header-title">{this.state.hoveredItem.label}</span>

                                {!isFlyoutSearchExpanded ? (
                                    <div
                                        type="button"
                                        className={`flyout-search-toggle ${isFlyoutSearchExpanded ? "is-active" : ""}`}
                                        onClick={this.toggleFlyoutSearch}
                                        aria-label={isFlyoutSearchExpanded ? "Close flyout search" : "Open flyout search"}
                                        aria-pressed={isFlyoutSearchExpanded}
                                    >
                                        <img className="search-icon" src={blueSearchIcon} alt="" />
                                    </div>
                                ) : null}
                            </div>
                            {isFlyoutSearchExpanded && (
                                <div className="flyout-search-wrap p-2 pr-3 pl-3">
                                    <input
                                        ref={this?.flyoutSearchInputRef}
                                        type="search"
                                        className="flyout-search-input"
                                        placeholder="Search..."
                                        value={flyoutSearchQuery}
                                        onChange={e => {
                                            this.setState({ flyoutSearchQuery: e.target?.value, isFlyoutSearchExpanded: true });
                                        }}
                                        onKeyDown={e => {
                                            e?.stopPropagation();
                                            if (e?.key === "Escape") {
                                                this.clearFlyoutSearch({ collapse: true });
                                            }
                                        }}
                                        onClick={e => e.stopPropagation()}
                                        onMouseDown={e => e.stopPropagation()}
                                        aria-label="Search menu items"
                                    />
                                    <i
                                        className="fas fa-times cursor-pointer cls-close"
                                        onClick={() => {
                                            this.clearFlyoutSearch({ collapse: true });
                                        }}
                                    ></i>
                                </div>
                            )}
                            <div className="flyout-items">
                                {(flyoutFilteredEntries ?? [])?.length === 0 ? (
                                    <div className="flyout-empty" role="status">
                                        No Data Found
                                    </div>
                                ) : (
                                    flyoutFilteredEntries.map(entry => {
                                        const node = entry?.node;
                                        const { pathname } = this.props.location;
                                        const isActive = node?.url && (pathname === node?.url || pathname === `/${node?.url}`);
                                        return (
                                            <React.Fragment key={node.key}>
                                                <div
                                                    onClick={() => {
                                                        const fullPath =
                                                            entry?.chain || (this.state.hoveredPath ? [...this.state.hoveredPath, node] : [node]);
                                                        const shouldKeepAccordionCollapsed = ["projects", "efci"].includes(fullPath?.[0]?.key);

                                                        this.handleSideNavClick(
                                                            node,
                                                            1,
                                                            () => {
                                                                this.setState({
                                                                    ...(shouldKeepAccordionCollapsed
                                                                        ? { activeFlyoutPath: fullPath }
                                                                        : { forceExpandPath: fullPath }),
                                                                    showFlyout: false,
                                                                    hoveredItem: null,
                                                                    flyoutSearchQuery: "",
                                                                    isFlyoutSearchExpanded: false
                                                                });
                                                            },
                                                            node
                                                        );

                                                        this.flyoutLeave();
                                                    }}
                                                    className="flyout-header-item"
                                                    style={{
                                                        color: isActive ? "#1a73e8" : "#333"
                                                    }}
                                                    onMouseEnter={e => {
                                                        if (!isActive) {
                                                            e.currentTarget.style.color = "#1a73e8";
                                                        }
                                                    }}
                                                    onMouseLeave={e => {
                                                        if (!isActive) {
                                                            e.currentTarget.style.color = "#333";
                                                        }
                                                    }}
                                                >
                                                    <span />
                                                    <img src={"/img/flyout-menu.svg"} alt="" />
                                                    {node.label}
                                                </div>
                                            </React.Fragment>
                                        );
                                    })
                                )}
                            </div>
                        </div>
                    </div>
                )}
                {this.renderGotoLandingPageConfirmationModal()}
                {this.renderQuickLinksConfirmationModal()}
            </>
        );
    }
}

const mapStateToProps = state => {
    const {
        commonReducer,
        dashboardReducer,
        buildingReducer,
        siteReducer,
        regionReducer,
        recommendationsReducer,
        projectReducer,
        userReducer,
        assetManagementReducer,
        assetReducer,
        dynamicTableReducer,
        assetDashboardReducer
    } = state;
    return {
        commonReducer,
        dashboardReducer,
        buildingReducer,
        recommendationsReducer,
        siteReducer,
        regionReducer,
        projectReducer,
        userReducer,
        assetManagementReducer,
        assetReducer,
        dynamicTableReducer,
        assetDashboardReducer
    };
};

export default withRouter(
    connect(mapStateToProps, {
        ...userActions,
        ...imageActions,
        ...CommonActions,
        ...buildingActions,
        ...siteActions,
        ...dashboardAction,
        ...regionActions,
        ...recommentationActions,
        addToQuickLinks,
        getQuickLinks,
        deleteQuickLinks,
        getPublishedDynamicTables: dynamicTableActions.getPublishedDynamicTables,
        saveMasterFilters: assetManagementActions.saveMasterFilters
    })(SideMenu)
);
